import { NewRequest, parseResponseAndHandleErrors, URLForEndpoint } from '@/data/requests'
import { ERROR_SERVER_UNREACHABLE } from '@/data/datasourceConst'
import axios from 'axios'
import jQuery from 'jquery'
import moment from 'moment'
import Cookies from 'js-cookie'
import { generateRandomIndex } from '@/helper/utily'
import { getBase, getUserID } from '@/helper/util_custom'

const API_HOST = process.env.VUE_APP_ROOT_API || 'http://local.emsv2'
const API_HOST2 = process.env.VUE_APP_ROOT_API2
let GoogleGeocodeAPIKey = 'AIzaSyBSjzdBEO1Akg0aZfKpglWYBtdqLMHJLzM'

function getMs() {
  const d = new Date()
  return d.getTime()
}

export default class DataSource {
  static get shared() {
    if (DataSource.instance == null) {
      DataSource.instance = new DataSource()
    }
    return DataSource.instance
  }

  async callAPI(endPoint, method = 'GET', queryObject, requestBody, hasContentType = true, host) {
    const url = URLForEndpoint(endPoint, queryObject, host)
    const request = NewRequest(method, hasContentType)

    if (!hasContentType) {
      delete request.headers['Content-Type']
      request.body = requestBody
    } else if (method !== 'GET' && requestBody) {
      request.body = JSON.stringify(requestBody)
    }
    let response
    try {
      response = await fetch(url, request)
    } catch (err) {
      throw ERROR_SERVER_UNREACHABLE
    }
    return response
  }

  async callWebService(endPoint, data = {}, method = 'GET', withToken = true, withFormData = false, isStringData = false, host) {
    const url = URLForEndpoint(endPoint, null, host)
    const request = {
      dataType: 'json',
      url: url,
      cache: false,
      success: function (response) {
        return response
      },
    }

    if (method) {
      request.method = method
    }

    if (data) {
      request.data = data
    }

    if (isStringData) {
      request.contentType = 'application/json'
    }

    if (withToken) {
      data.token = Cookies.get('authToken')
      data.UserSchool_Session = Cookies.get('schoolSession')
      data.UserID_Session = Cookies.get('userIDSession')
      data.UserType_Session = Cookies.get('userTypeSession')
      data.UserUniversity_Session = Cookies.get('userUniversitySession')
      data.UserEmail_Session = Cookies.get('userEmailSession')
      data.USRid_Session = Cookies.get('usRidSession')
      data.UserName_Session = Cookies.get('userNameSession')
      data.UserSchoolName_Session = Cookies.get('userSchoolNameSession')
      data.UserSchoolInfoSerialize_Session = Cookies.get('userSchoolInfoSerializeSession')
      const extendTime = Cookies.get('extendTime')
      const expireTime = Cookies.get('expireTime')
      const nowMs = getMs()

      if (nowMs >= extendTime && nowMs < expireTime) {
        const newExtendDate = new Date(Number(expireTime) + 120 * 60 * 1000)
        if (newExtendDate.getTime() >= Number(expireTime)) {
          const newExpireDate = new Date(Number(expireTime) + 180 * 60 * 1000)
          this.extendCookies(newExpireDate, newExtendDate)
        }
      }
    }

    if (withFormData) {
      request.processData = false
      request.contentType = false
    }

    try {
      return await jQuery.ajax(request)
    } catch (e) {
      console.error(e)
    }
  }

  async login(userId, password) {
    const data = {
      userID: userId,
      userPassword: password,
      type: 'Kagami Website',
    }

    try {
      let extendDate = new Date(new Date().getTime() + 120 * 60 * 1000)
      let expireDate = new Date(new Date().getTime() + 180 * 60 * 1000)
      const extendMs = extendDate.getTime()
      const expiredMs = expireDate.getTime()

      const response = await this.callWebService('/controller/Login.asmx/checkLogin', data, 'POST', false)
      Cookies.set('authToken', response.token, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('schoolSession', response.UserSchool_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userIDSession', response.UserID_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userTypeSession', response.UserType_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userUniversitySession', response.UserUniversity_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('usRidSession', response.USRid_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userEmailSession', response.UserEmail_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userNameSession', response.UserName_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('expireTime', expiredMs, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('extendTime', extendMs, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userSchoolNameSession', response.UserSchoolName_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userSchoolInfoSerializeSession', response.SchoolInfoSerialize_Session, { expires: expireDate }) //expire in 3 hour)
      return response
    } catch (e) {
      throw e
    }
  }

  async login_parent(userId, password) {
    const data = {
      userID: userId,
      userPassword: password,
      type: 'Kagami Website Parent',
    }

    try {
      let extendDate = new Date(new Date().getTime() + 120 * 60 * 1000)
      let expireDate = new Date(new Date().getTime() + 180 * 60 * 1000)
      const extendMs = extendDate.getTime()
      const expiredMs = expireDate.getTime()

      const response = await this.callWebService('/controller/Login.asmx/checkParentLogin', data, 'POST', false)
      Cookies.set('authToken', response.token, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('schoolSession', response.UserSchool_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userIDSession', response.UserID_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userTypeSession', response.UserType_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userUniversitySession', response.UserUniversity_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('usRidSession', response.USRid_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userEmailSession', response.UserEmail_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userNameSession', response.UserName_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('expireTime', expiredMs, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('extendTime', extendMs, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userSchoolNameSession', response.UserSchoolName_Session, { expires: expireDate }) //expire in 3 hour);
      Cookies.set('userSchoolInfoSerializeSession', response.SchoolInfoSerialize_Session, { expires: expireDate }) //expire in 3 hour)
      return response
    } catch (e) {
      throw e
    }
  }

  extendCookies(expireDate, extendTime) {
    const token = Cookies.get('authToken')
    const UserSchool_Session = Cookies.get('schoolSession')
    const UserID_Session = Cookies.get('userIDSession')
    const UserType_Session = Cookies.get('userTypeSession')
    const UserUniversity_Session = Cookies.get('userUniversitySession')
    const UserEmail_Session = Cookies.get('userEmailSession')
    const USRid_Session = Cookies.get('usRidSession')
    const UserName_Session = Cookies.get('userNameSession')
    const expiredMs = expireDate.getTime()
    const extendMs = extendTime.getTime()
    const UserSchoolName_Session = Cookies.get('userSchoolNameSession')
    const UserSchoolInfoSerializeSession = Cookies.get('userSchoolInfoSerializeSession')
    Cookies.set('authToken', token, { expires: expireDate }) //expire in 3 hour);
    Cookies.set('schoolSession', UserSchool_Session, { expires: expireDate }) //expire in 3 hour);
    Cookies.set('userIDSession', UserID_Session, { expires: expireDate }) //expire in 3 hour);
    Cookies.set('userTypeSession', UserType_Session, { expires: expireDate }) //expire in 3 hour);
    Cookies.set('userUniversitySession', UserUniversity_Session, { expires: expireDate }) //expire in 3 hour);
    Cookies.set('usRidSession', USRid_Session, { expires: expireDate }) //expire in 3 hour);
    Cookies.set('userEmailSession', UserEmail_Session, { expires: expireDate }) //expire in 3 hour);
    Cookies.set('userNameSession', UserName_Session, { expires: expireDate }) //expire in 3 hour);
    Cookies.set('expireTime', expiredMs, { expires: expireDate }) //expire in 3 hour);
    Cookies.set('extendTime', extendMs, { expires: expireDate }) //expire in 3 hour);
    Cookies.set('userSchoolNameSession', UserSchoolName_Session, { expires: expireDate }) //expire in 3 hour);
    Cookies.set('userSchoolInfoSerializeSession', UserSchoolInfoSerializeSession, { expires: expireDate }) //expire in 3 hour);
  }

  async externalLogin(userId, tokenId) {
    const data = {
      userID: userId,
      externalLoginToken: tokenId,
      type: 'Kagami Website',
    }

    const response = await this.callWebService('/controller/Login.asmx/checkLogin', data, 'POST', false)
    Cookies.set('authToken', response.token, { expires: 3 / 24 }) //expire in 3 hour);
    Cookies.set('schoolSession', response.UserSchool_Session, { expires: 3 / 24 }) //expire in 3 hour);
    Cookies.set('userIDSession', response.UserID_Session, { expires: 3 / 24 }) //expire in 3 hour);
    Cookies.set('userTypeSession', response.UserType_Session, { expires: 3 / 24 }) //expire in 3 hour);
    Cookies.set('userUniversitySession', response.UserUniversity_Session, { expires: 3 / 24 }) //expire in 3 hour);
    Cookies.set('usRidSession', response.USRid_Session, { expires: 3 / 24 }) //expire in 3 hour);
    Cookies.set('userEmailSession', response.UserEmail_Session, { expires: 3 / 24 }) //expire in 3 hour);
    Cookies.set('userNameSession', response.UserName_Session, { expires: 3 / 24 }) //expire in 3 hour);
    return response
  }

  logout() {
    let $ = require('jquery')

    let internalSession = new Promise(resolve => {
      const data = {}

      this.callWebService('/controller/Login.asmx/logOut', data, 'POST').then(result => {
        resolve(result === '1')
      })
    })

    let sessionSignout = new Promise(resolve => {
      Cookies.remove('authToken')
      Cookies.remove('schoolSession')
      Cookies.remove('userIDSession')
      Cookies.remove('userTypeSession')
      Cookies.remove('userUniversitySession')
      Cookies.remove('usRidSession')
      Cookies.remove('userEmailSession')
      Cookies.remove('userNameSession')
      resolve(true)
    })

    let googleSignout = new Promise(resolve => {
      $.getScript('https://apis.google.com/js/platform.js', function () {
        gapi.load('auth2', () => {
          gapi.auth2
            .init({
              client_id: '646978523324-lcudp248dvuuk0rda4q6kf2bti9qkk3b.apps.googleusercontent.com',
            })
            .then(auth2 => {
              auth2.signOut()
              resolve(true)
            })
        })
      })
    })

    let fbSignout = new Promise(resolve => {
      $.getScript('https://connect.facebook.net/en_US/sdk.js', function () {
        FB.init({
          appId: '1983777365262188',
          version: 'v2.7', // or v2.1, v2.2, v2.3, ...
        })

        FB.getLoginStatus(() => {
          FB.logout()
          resolve(true)
        })
      })
    })

    Promise.all([internalSession, sessionSignout, googleSignout, fbSignout]).then(() => {
      window.location.replace('/login')
    })
  }

  async resetEmailPassword(userEmail, type) {
    const data = {
      userEmail: userEmail,
      type: type,
    }
    return await this.callWebService('/controller/Login.asmx/resetPasswordEmail', data, 'POST', false)
  }

  async resetPassword(userEmail, userPassword, otp) {
    const data = {
      userEmail: userEmail,
      userPassword: userPassword,
      otp: otp,
    }
    return await this.callWebService('/controller/Login.asmx/resetPassword', data, 'POST', false)
  }

  async parentRegister(userEmail, userPassword, studentIDNo, studentID_Index, studentDOB, studentIDType, externalLoginType, externalLoginToken) {
    const date = moment(studentDOB).format('Y-MM-DD HH:mm:ss')
    console.log(date)
    const data = {
      userEmail: userEmail,
      userPassword: userPassword,
      studentID_Index: studentID_Index,
      studentDOB: date,
      studentIDType: studentIDType,
      studentIDNo: studentIDNo,
      externalLoginType: externalLoginType,
      externalLoginToken: externalLoginToken,
    }
    let response = await this.callWebService('/controller/Register.asmx/parentRegistration', data, 'POST', false)

    if (typeof response === 'string') {
      response = JSON.parse(response)
    }

    return response
  }

  async getStudent(studentID, studentID_Index, studentFirstName, studentLastName, parentName) {
    const data = {
      studentID: studentID,
      studentID_Index: studentID_Index,
      studentFirstName: studentFirstName,
      studentLastName: studentLastName,
      parentName: parentName,
    }
    return await this.callWebService('/controller/Students.asmx/getStudent', data, 'POST')
  }

  async getStudentParentView(studentID) {
    const data = {
      studentID: studentID,
      parentView: 'YES',
    }
    return await this.callWebService('/controller/Students.asmx/getStudent', data, 'POST')
  }

  async getStudentWithStatus(studentID, studentID_Index, studentFirstName, studentLastName, parentName, studentStatus, type) {
    const data = {
      studentID: studentID,
      studentID_Index: studentID_Index,
      studentFirstName: studentFirstName,
      studentLastName: studentLastName,
      parentName: parentName,
      studentStatus: studentStatus,
      type: type,
    }
    return await this.callWebService('/controller/Students.asmx/getStudent', data, 'POST')
  }

  async getStudentWithPendingCourse(
    studList,
    studentID_Index,
    studentFirstName,
    studentLastName,
    parentName,
    studentStatus,
    levelID,
    classID,
    classType,
    mode,
    teacherID,
  ) {
    const data = {
      studList: studList,
      teacherID: teacherID,
      studentID_Index: studentID_Index,
      studentFirstName: studentFirstName,
      studentLastName: studentLastName,
      parentName: parentName,
      studentStatus: studentStatus,
      levelID: levelID,
      classID: classID,
      classType: classType,
      mode: mode,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentWithPendingCourse', data, 'POST')
  }

  async checkStudentDuplication(studentFirstName, studentLastName, studentDOB, finExpire, fin, birthCert, ic, passport, passportExpire) {
    const data = {
      studentFirstName: studentFirstName,
      studentLastName: studentLastName,
      studentDOB: studentDOB,
      finExpire: finExpire,
      fin: fin,
      birthCert: birthCert,
      ic: ic,
      passport: passport,
      passportExpire: passportExpire,
    }
    return await this.callWebService('/controller/Students.asmx/checkStudentDuplication', data, 'POST')
  }

  async getStudentProfilePicture(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentProfilePicture', data, 'POST')
  }

  async getStudentAddressGoogleAPI(postcode, country) {
    let result = ''

    if (country === '' || country === 'Singapore') {
      country = 'Singapore'

      if (postcode.substring(0, 1).toUpperCase() === 'S') {
        postcode = postcode.substring(1, postcode.length)
      }
    }

    const request = {
      url: 'https://maps.googleapis.com/maps/api/geocode/json?address=' + postcode + '+' + country + '&result_type=street_address&key=' + GoogleGeocodeAPIKey,
      cache: false,
      type: 'POST',
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }

    let lat = ''
    let lng = ''

    this.resultResponse = response.results
    this.resultResponse.forEach(m => {
      lat = m.geometry.location.lat
      lng = m.geometry.location.lng
    })

    if (response.status === 'OK') {
      const request2 = {
        url: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lng + '&key=' + GoogleGeocodeAPIKey,
        cache: false,
        type: 'POST',
        enctype: 'multipart/form-data',
        processData: false,
        contentType: false,
        async: false,
        json: false,
        success: function (response2) {
          return response2
        },
      }

      let response2 = await jQuery.ajax(request2)
      if (typeof response2 === 'string') {
        response2 = JSON.parse(response2)
      }

      result = response2.results[0].formatted_address
    }

    return result
  }

  async oneMapCommonApiSearchVal(value) {
    const request = {
      url: 'https://developers.onemap.sg/commonapi/search?searchVal=' + value + '&returnGeom=Y&getAddrDetails=Y',
      cache: false,
      type: 'GET',
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async saveStudent(files, jsonString, jsonString2, familyID, parentID, allergiesList, authorizedPickupList, classID) {
    const data = new FormData()
    data.append('token', Cookies.get('authToken'))
    data.append('UserSchool_Session', Cookies.get('schoolSession'))
    data.append('UserID_Session', Cookies.get('userIDSession'))
    data.append('UserUniversity_Session', Cookies.get('userUniversitySession'))

    if (files && files.length > 1) {
      for (let key in files) {
        if (files.hasOwnProperty(key)) {
          if (key > 0) {
            data.append(`upload_${key}`, files[key])
          } else {
            data.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      data.append('upload', files[0])
    }

    data.append('jsonString', jsonString)
    data.append('jsonString2', jsonString2)
    data.append('familyID', familyID)
    data.append('parentID', parentID)
    data.append('allergiesList', allergiesList)
    data.append('authorizedPickupList', authorizedPickupList)
    data.append('classID', classID)

    const request = {
      url: `${API_HOST}/controller/Students.asmx/saveStudent`,
      cache: false,
      type: 'POST',
      data: data,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async updateStudent(files, studentID, jsonString, allergiesList, authorizedPickupList) {
    const data = new FormData()
    data.append('token', Cookies.get('authToken'))
    data.append('UserID_Session', Cookies.get('userIDSession'))

    if (files && files.length > 1) {
      for (let key in files) {
        if (files.hasOwnProperty(key)) {
          if (key > 0) {
            data.append(`upload_${key}`, files[key])
          } else {
            data.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      data.append('upload', files[0])
    }

    data.append('studentID', studentID)
    data.append('jsonString', jsonString)
    data.append('allergiesList', allergiesList)
    data.append('authorizedPickupList', authorizedPickupList)

    const request = {
      url: `${API_HOST}/controller/Students.asmx/updateStudent`,
      cache: false,
      type: 'POST',
      data: data,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async requestResetParentPassword(parentId, parentEmail) {
    const data = {
      parentID: parentId,
      email: parentEmail,
    }
    return await this.callWebService('/controller/Parents.asmx/resetParentPassword', data, 'POST')
  }

  async getStudentAvailableStatusAction(currentStatus, currentIndexNo, currentStudentID) {
    const data = {
      currentStatus: currentStatus,
      currentIndexNo: currentIndexNo,
      currentStudentID: currentStudentID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentAvailableStatusAction', data, 'POST')
  }

  async updateStudentStatus(studentID, newStatus, rejectedReason, rejectedDate) {
    const data = {
      studentID: studentID,
      newStatus: newStatus,
      rejectedReason: rejectedReason,
      rejectedDate: rejectedDate,
    }
    return await this.callWebService('/controller/Students.asmx/updateStudentStatus', data, 'POST')
  }

  async getParentList(familyId, parentFirstName, parentLastName, parentEmail) {
    const data = {
      familyID: familyId,
      parentFirstName: parentFirstName,
      parentLastName: parentLastName,
      parentEmail: parentEmail,
      // token: Cookies.get('authToken'),
      // UserSchool_Session: Cookies.get('schoolSession'),
    }
    return await this.callWebService('/controller/Parents.asmx/getParentList', data, 'POST')
  }

  async getParent(parentID, familyID, emailJsonString) {
    const data = {
      parentID: parentID,
      familyID: familyID,
      emailJsonString: emailJsonString,
    }
    return await this.callWebService('/controller/Parents.asmx/getParent', data, 'POST')
  }

  async getParentStudentsInfo(parentID) {
    const data = {
      parentID: parentID,
    }
    return await this.callWebService('/controller/Parents.asmx/getParentStudentsInfo', data, 'POST')
  }

  async getRelationship(familyID, studentID, parentFirstName, parentLastName, studentName) {
    const data = {
      familyID: familyID,
      studentID: studentID,
      parentFirstName: parentFirstName,
      parentLastName: parentLastName,
      studentName: studentName,
    }
    return await this.callWebService('/controller/Parents.asmx/getRelationship', data, 'POST')
  }

  async getRelationshipByParentID(parentID) {
    const data = {
      parentID: parentID,
    }
    return await this.callWebService('/controller/Parents.asmx/getRelationship', data, 'POST')
  }

  async getStudentSiblingReligionLanguages(parentID) {
    const data = {
      parentID: parentID,
    }
    return await this.callWebService('/controller/Parents.asmx/getStudentSiblingReligionLanguages', data, 'POST')
  }

  async updateRelationship(familyID, studentID) {
    const data = {
      familyID: familyID,
      studentID: studentID,
    }
    return await this.callWebService('/controller/Parents.asmx/updateRelationship', data, 'POST')
  }

  async getStudentLevel(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentLevel', data, 'POST')
  }

  async getStudentAllLevel(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentAllLevel', data, 'POST')
  }

  async getStudentLevelActiveOnly(studentID) {
    const data = {
      studentID: studentID,
      onlyActive: 'Yes',
    }
    return await this.callWebService('/controller/Students.asmx/getStudentLevel', data, 'POST')
  }

  async massSetClass(classID, jsonString) {
    const data = {
      classID: classID,
      jsonString: jsonString,
    }
    return await this.callWebService('/controller/Students.asmx/massSetClass', data, 'POST')
  }

  async getSibling(studentID_Index, studentID) {
    const data = {
      studentID_Index: studentID_Index,
      studentID: studentID,
    }
    return await this.callWebService('/controller/Students.asmx/getSibling', data, 'POST')
  }

  async updateParent(parentID, jsonString) {
    const data = {
      parentID: parentID,
      jsonString: jsonString,
    }
    return await this.callWebService('/controller/Parents.asmx/updateParent', data, 'POST')
  }

  async setLevel(mode, studentID, crsID, semID, commencementDate, studentSchoolID) {
    const data = {
      mode: mode,
      studentID: studentID,
      crsID: crsID,
      semID: semID,
      commencementDate: commencementDate,
      studentSchoolID: studentSchoolID,
    }
    return await this.callWebService('/controller/Students.asmx/setLevel', data, 'POST')
  }

  async setLevelAllowTodayDate(mode, studentID, crsID, semID, commencementDate, studentSchoolID) {
    const data = {
      mode: mode,
      studentID: studentID,
      crsID: crsID,
      semID: semID,
      commencementDate: commencementDate,
      studentSchoolID: studentSchoolID,
    }
    return await this.callWebService('/controller/Students.asmx/setLevelAllowTodayDate', data, 'POST')
  }

  async checkParentDuplication(firstName, lastName, checkMode) {
    const data = {
      firstName: firstName,
      lastName: lastName,
      checkMode: checkMode,
    }
    return await this.callWebService('/controller/Parents.asmx/checkParentDuplication', data, 'POST')
  }

  async getUserMenu() {
    const data = {}

    const userType = Cookies.get('userTypeSession')
    if (userType !== 'Parent') {
      data.USRid_Session = Cookies.get('usRidSession')
    }

    return await this.callWebService('/controller/User.asmx/getUserMenu', data, 'POST')
  }

  async getUserSch() {
    const data = {}

    const userEmail = Cookies.get('userEmailSession')
    if (userEmail !== '' || userEmail !== null) {
      data.UserEmail_Session = Cookies.get('userEmailSession')
    }

    const response = await this.callWebService('/controller/User.asmx/getUserSch', data, 'POST')
    if (response.Table) {
      window.schList = response.Table
    }

    return response
  }

  async getAllStaffListBySchool() {
    const data = {}

    return await this.callWebService('/controller/User.asmx/getAllStaffListBySchool', data, 'POST')
  }

  async getAllStaffList() {
    const data = {}

    return await this.callWebService('/controller/User.asmx/getAllStaffList', data, 'POST')
  }

  async getStaffPost(int_NumberOfPost, str_LastPostID, postType) {
    const data = {
      UserID_Session: Cookies.get('userIDSession'),
      numberOfPost: int_NumberOfPost,
      lastPostID: str_LastPostID,
      postType: postType,
    }

    return await this.callWebService('/controller/Posting.asmx/getPostStaff', data, 'POST')
  }

  async getStaffPostFeedPage(
    int_NumberOfPost,
    str_LastPostID,
    postType,
    notEqualPostType,
    mode,
    equalPostType,
    postTagValue,
    fromDate,
    toDate,
    postStatus,
    postTagValueEqual,
  ) {
    const data = {
      UserID_Session: Cookies.get('userIDSession'),
      numberOfPost: int_NumberOfPost,
      lastPostID: str_LastPostID,
      postType: postType,
      notEqualPostType: notEqualPostType,
      mode: mode,
      equalPostType: equalPostType,
      // postTagValue: postTagValue,
      postTagValueWithNewsFeedPostContent: postTagValue,
      fromDate: fromDate,
      toDate: toDate,
      postStatus: postStatus,
      postTagValueEqual,
    }

    return await this.callWebService('/controller/Posting.asmx/getPostStaff', data, 'POST')
  }

  async getFilterPost(numberOfPost, schoolid, classid, studentid, teacherid, fromDate, toDate, levelid) {
    const data = {
      numberOfPost: numberOfPost,
      schoolid: JSON.stringify(schoolid),
      classid: JSON.stringify(classid),
      levelid: JSON.stringify(levelid),
      studentid: JSON.stringify(studentid),
      teacherid: JSON.stringify(teacherid),
      fromDate: fromDate,
      toDate: toDate,
    }
    console.log(data, 'data')
    return await this.callWebService('/controller/Api.asmx/GetPosts', data, 'POST')
  }

  async getStaffPostFeedPageByClass(
    int_NumberOfPost,
    str_LastPostID,
    postType,
    notEqualPostType,
    mode,
    equalPostType,
    postTagValue,
    fromDate,
    toDate,
    postStatus,
    postTagValueEqual,
  ) {
    const data = {
      UserID_Session: Cookies.get('userIDSession'),
      numberOfPost: int_NumberOfPost,
      lastPostID: str_LastPostID,
      postType: postType,
      notEqualPostType: notEqualPostType,
      mode: mode,
      equalPostType: equalPostType,
      // postTagValue: postTagValue,
      postTagValueWithNewsFeedPostContent: postTagValue,
      fromDate: fromDate,
      toDate: toDate,
      postStatus: postStatus,
      postTagValueEqual: postTagValueEqual,
    }

    return await this.callWebService('/controller/Posting.asmx/getPostStaffByClass', data, 'POST')
  }

  async getStaffActivityPostAllByClass(
    int_NumberOfPost,
    str_LastPostID,
    postType,
    notEqualPostType,
    mode,
    equalPostType,
    postTagValue,
    fromDate,
    toDate,
    postStatus,
    postTagValueEqual,
    userRole,
    schoolid = [],
    levelid = [],
    classid = [],
    studentid = [],
    teacherid = [],
    isAllLevel,
  ) {
    const data = {
      UserID_Session: Cookies.get('userIDSession'),
      numberOfPost: int_NumberOfPost,
      lastPostID: str_LastPostID,
      postType: postType,
      notEqualPostType: notEqualPostType,
      mode: mode,
      equalPostType: equalPostType,
      // postTagValue: postTagValue,
      postTagValueWithNewsFeedPostContent: postTagValue,
      fromDate: fromDate,
      toDate: toDate,
      postStatus: postStatus,
      postTagValueEqual: postTagValueEqual,
      userRole: userRole,
      schoolid: JSON.stringify(schoolid),
      levelid: JSON.stringify(levelid),
      classid: JSON.stringify(classid),
      studentid: JSON.stringify(studentid),
      teacherid: JSON.stringify(teacherid),
      isAllLevel: isAllLevel,
    }
    return await this.callWebService('/controller/Api.asmx/GetPosts', data, 'POST')
  }

  async getEditorUploadURL(file) {
    const formData = new FormData()
    formData.append('token', Cookies.get('authToken'))
    formData.append('file0', file)

    const request = {
      url: `${API_HOST}/controller/Api.asmx/UploadFile`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }
    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async getParentPost(int_NumberOfPost, str_LastPostID, postType, fromDate, toDate) {
    const data = {
      UserID_Session: Cookies.get('userIDSession'),
      numberOfPost: int_NumberOfPost,
      lastPostID: str_LastPostID,
      postType: postType,
      fromDate: fromDate,
      toDate: toDate,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostParent', data, 'POST')
  }

  async getParentPostFeedPage(
    int_NumberOfPost,
    str_LastPostID,
    postType,
    notEqualPostType,
    mode,
    equalPostType,
    postTagValue,
    postContent,
    studentID,
    fromDate,
    toDate,
    postTagValueEqual,
    postTagValueNotEqual,
  ) {
    const data = {
      UserID_Session: Cookies.get('userIDSession'),
      numberOfPost: int_NumberOfPost,
      lastPostID: str_LastPostID,
      postType: postType,
      notEqualPostType: notEqualPostType,
      mode: mode,
      equalPostType: equalPostType,
      postTagValue: postTagValue,
      postContent: postContent,
      studentID: studentID,
      fromDate: fromDate,
      toDate: toDate,
      postTagValueEqual: postTagValueEqual,
      postTagValueNotEqual: postTagValueNotEqual,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostParent', data, 'POST')
  }

  async getPostDropdown() {
    const data = {}
    return await this.callWebService('/controller/Posting.asmx/getPostDropDown', data, 'POST')
  }

  async uploadPostMedia(files) {
    const formData = new FormData()
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    if (files && files.length > 1) {
      for (let key in files) {
        // console.log(key);
        if (files.hasOwnProperty(key)) {
          // console.log(files[key]);
          if (key > 0) {
            formData.append(`upload_${key}`, files[key])
          } else {
            formData.append('upload', files[key])
          }
        }
      }
    } else if (files && files.length) {
      formData.append('upload', files[0])
    } else {
      formData.append('upload', files)
    }

    return await this.callWebService('/controller/Api.asmx/Upload', formData, 'POST', true, true)
  }

  async uploadFiles(files) {
    const formData = new FormData()
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    if (files && files.length > 1) {
      for (let key in files) {
        // console.log(key);
        if (files.hasOwnProperty(key)) {
          // console.log(files[key]);
          if (key > 0) {
            formData.append(`upload_${key}`, files[key])
          } else {
            formData.append('upload', files[key])
          }
        }
      }
    } else if (files && files.length) {
      formData.append('upload', files[0])
    } else {
      formData.append('upload', files)
    }

    const request = {
      url: `${API_HOST}/controller/Api.asmx/UploadFiles`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async savePostUpdate(
    files,
    tagUserID,
    tagClassID,
    tagLevelID,
    postLinkID,
    postAllowComment,
    postKeyTag,
    postStatus,
    isAllLevel,
    isAllClasses,
    postType,
    scheduleDate,
    scheduleStatus,
    uploadDates,
    postObervation,
    { title, content, content2, content3, content4, ungroupDevelopmentGoals },
  ) {
    // const postType = "UPDATE";
    const formData = new FormData()
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('postLinkID', postLinkID)
    formData.append('postAllowComment', postAllowComment)
    formData.append('updateLearningMoments', JSON.stringify(ungroupDevelopmentGoals))
    formData.append('uploadDates', uploadDates)
    formData.append('postKeyTag', postKeyTag)
    formData.append('postStatus', postStatus)
    if (scheduleStatus || scheduleDate) {
      formData.append('ScheduledDate', scheduleDate)
      formData.append('ScheduledStatus', scheduleStatus)
    }
    formData.append('uploadFiles', JSON.stringify(files))
    formData.append('PostUpdDtlTitle', title)
    formData.append('content1', content !== undefined ? encodeURIComponent(content) : null)
    formData.append('broadContent', content !== undefined ? encodeURIComponent(content) : null)
    formData.append('content2', content2 !== undefined ? encodeURIComponent(content2) : null)
    formData.append('content3', content3 !== undefined ? encodeURIComponent(content3) : null)
    formData.append('content4', content4 !== undefined ? encodeURIComponent(content4) : null)
    // formData.append("tagAcademicYearID", tagAcademicYearID);
    formData.append('postType', postType)
    if (isAllLevel === 1) {
      formData.append('isAllLevel', isAllLevel)
    }
    if (tagUserID && tagUserID.length > 0) {
      formData.append('tagUserID', tagUserID)
    }
    if (tagLevelID && tagLevelID.length > 0) {
      formData.append('tagLevelID', tagLevelID)
    }
    if (tagClassID && tagClassID.length > 0) {
      formData.append('tagClassID', tagClassID)
    }

    return await this.callWebService('/controller/Posting.asmx/savePost', formData, 'POST', true, true)
  }

  async savePostUpdateJapan(
    files,
    postContent,
    tagUserID,
    tagClassID,
    tagLevelID,
    postLinkID,
    postAllowComment,
    updateLearningMoments,
    postKeyTag,
    postStatus,
    isAllLevel,
    isAllClasses,
    postTitle,
    postType,
    scheduleDate,
    scheduleStatus,
  ) {
    // const postType = "UPDATE";
    const formData = new FormData()
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('postLinkID', postLinkID)
    formData.append('postAllowComment', postAllowComment)
    formData.append('updateLearningMoments', updateLearningMoments)
    formData.append('postKeyTag', postKeyTag)
    formData.append('postStatus', postStatus)
    if (scheduleStatus || scheduleDate) {
      formData.append('ScheduledDate', scheduleDate)
      formData.append('ScheduledStatus', scheduleStatus)
    }
    formData.append('uploadFiles', JSON.stringify(files))

    formData.append('PostUpdDtlTitle', postTitle)
    formData.append('content1', postContent ? encodeURIComponent(postContent) : null)
    formData.append('broadContent', postContent ? encodeURIComponent(postContent) : null)
    // formData.append("broadContent", postContent);
    // formData.append("tagAcademicYearID", tagAcademicYearID);
    formData.append('postType', postType)
    if (isAllLevel === 1) {
      formData.append('isAllLevel', isAllLevel)
    }
    if (tagUserID && tagUserID.length > 0) {
      formData.append('tagUserID', tagUserID)
    }
    if (tagLevelID && tagLevelID.length > 0) {
      formData.append('tagLevelID', tagLevelID)
    }
    if (tagClassID && tagClassID.length > 0) {
      formData.append('tagClassID', tagClassID)
    }

    const request = {
      url: `${API_HOST}/controller/Posting.asmx/savePost`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async sendPushNotification(postid) {
    const BASE_URL = getBase()
    return await this.callWebService(`Communications/Action/SendPushNotification/post/${postid}`, {}, 'POST', true, false, false, `${BASE_URL}/`)
  }

  async savePortfolioPost(
    files,
    porTitle,
    porObservation,
    porAnalysisReflection,
    porDevelopmentObject,
    tagUserID,
    tagClassID,
    tagLevelID,
    postLinkID,
    porPorfolioObject,
    porPortfolioThemes,
    porResearchQuestion,
  ) {
    const postType = 'PORTFOLIO'
    const formData = new FormData()
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('porTitle', porTitle)
    formData.append('porObservation', porObservation)
    formData.append('porAnalysisReflection', porAnalysisReflection)
    formData.append('porDevelopmentObject', porDevelopmentObject)
    formData.append('postLinkID', postLinkID)
    formData.append('porPorfolioObject', porPorfolioObject)
    formData.append('porPortfolioThemes', porPortfolioThemes)
    formData.append('porResearchQuestion', porResearchQuestion)

    if (files && files.length > 1) {
      for (let key in files) {
        // console.log(key);
        if (files.hasOwnProperty(key)) {
          // console.log(files[key]);
          if (key > 0) {
            formData.append(`upload_${key}`, files[key])
          } else {
            formData.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      formData.append('upload', files[0])
    }

    // formData.append("tagAcademicYearID", tagAcademicYearID);
    formData.append('postType', postType)

    if (tagUserID && tagUserID.length > 0) {
      formData.append('tagUserID', tagUserID)
    } else if (tagLevelID) {
      formData.append('tagLevelID', tagLevelID)
    } else if (tagClassID) {
      formData.append('tagClassID', tagClassID)
    }

    const request = {
      url: `${API_HOST}/controller/Posting.asmx/savePost`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async saveDocumentPost(files, docContent, postLinkID) {
    const postType = 'DOCUMENTATION'
    const formData = new FormData()
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('docContent', docContent)
    formData.append('postLinkID', postLinkID)

    if (files && files.length > 1) {
      for (let key in files) {
        // console.log(key);
        if (files.hasOwnProperty(key)) {
          // console.log(files[key]);
          if (key > 0) {
            formData.append(`upload_${key}`, files[key])
          } else {
            formData.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      formData.append('upload', files[0])
    }

    // formData.append("tagAcademicYearID", tagAcademicYearID);
    formData.append('postType', postType)

    if (tagUserID && tagUserID.length > 0) {
      formData.append('tagUserID', '')
    } else if (tagLevelID) {
      formData.append('tagLevelID', '')
    } else if (tagClassID) {
      formData.append('tagClassID', '')
    }

    const request = {
      url: `${API_HOST}/controller/Posting.asmx/savePost`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async saveBroadcastPost(files, broadContent, tagUserID, tagClassID, tagLevelID, postLinkID, broadMessage) {
    const postType = 'BROADCAST'
    const formData = new FormData()
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('broadContent', broadContent)
    formData.append('postLinkID', postLinkID)
    formData.append('broadMsg', broadMessage)

    if (files && files.length > 1) {
      for (let key in files) {
        // console.log(key);
        if (files.hasOwnProperty(key)) {
          // console.log(files[key]);
          if (key > 0) {
            formData.append(`upload_${key}`, files[key])
          } else {
            formData.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      formData.append('upload', files[0])
    }

    // formData.append("tagAcademicYearID", tagAcademicYearID);
    formData.append('postType', postType)

    if (tagUserID && tagUserID.length > 0) {
      formData.append('tagUserID', tagUserID)
    } else if (tagLevelID) {
      formData.append('tagLevelID', tagLevelID)
    } else if (tagClassID) {
      formData.append('tagClassID', tagClassID)
    }

    const request = {
      url: `${API_HOST}/controller/Posting.asmx/savePost`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async getPostFile(postID) {
    const data = {
      postID: postID,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostFile', data, 'POST')
  }

  async getPostFileWithoutTokenCheckByEncryptedPostID(encryptedPostID) {
    const data = {
      encryptedPostID: encryptedPostID,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostFileWithoutTokenCheckByEncryptedPostID', data, 'POST')
  }

  async getPostAllTaggingStudentsByPostID(postID, postStatus) {
    const data = {
      postID: postID,
      postStatus: postStatus,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostAllTaggingStudentsByPostID', data, 'POST')
  }

  async getPostTagListByPostID(postID) {
    const data = {
      postID: postID,
    }
    return await this.callWebService('/controller/Posting.asmx/postTagLists', data, 'POST')
  }

  async saveComment(PostID, postContent) {
    const data = {
      postID: PostID,
      postContent: postContent,
    }
    return await this.callWebService('/controller/Posting.asmx/savePostComment', data, 'POST')
  }

  async getComment(PostID) {
    const data = {
      postId: PostID,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostComment', data, 'POST')
  }

  async editComment(commentPostID, postContent, actionMode) {
    const data = {
      commentPostID: commentPostID,
      postContent: postContent,
      actionMode: actionMode,
    }
    return await this.callWebService('/controller/Posting.asmx/updatePostComment', data, 'POST')
  }

  async deleteComment(commentPostID, postContent, actionMode) {
    const data = {
      commentPostID: commentPostID,
      postContent: postContent,
      actionMode: actionMode,
    }
    return await this.callWebService('/controller/Posting.asmx/updatePostComment', data, 'POST')
  }

  async pendingPost(ID, PostID, PostContent, PostStatus, PostCreatedDate, PostApproverID) {
    const data = {
      ID: ID,
      PostID: PostID,
      PostContent: PostContent,
      PostStatus: PostStatus,
      PostCreatedDate: PostCreatedDate,
      PostApproverID: PostApproverID,
    }
    data.UserID_Session = Cookies.get('userIDSession')
    return await this.callWebService('/controller/Approver.asmx/getPendingApproverPost', data, 'POST')
  }

  async approvePost(postID, postType, actionStatus, postComment) {
    const data = {
      postID: postID,
      postType: postType,
      actionStatus: actionStatus,
      postComment: postComment,
    }

    return await this.callWebService('/controller/Posting.asmx/approvePost', data, 'POST')
  }

  async updatePost(currentFiles, actionStatus, postID, UpdateContent, profolio, tagUserID, tagClassID, tagLevelID) {
    const formData = new FormData()
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    console.log(currentFiles)
    if (currentFiles && currentFiles.length > 1) {
      for (let key in currentFiles) {
        // console.log(key);
        if (currentFiles.hasOwnProperty(key)) {
          // console.log(files[key]);
          if (key > 0) {
            formData.append(`upload_${key}`, currentFiles[key])
          } else {
            formData.append('upload', currentFiles[key])
          }
        }
      }
    } else if (currentFiles) {
      formData.append('upload', currentFiles[0])
    }

    formData.append('actionStatus', actionStatus)
    formData.append('postID', postID)
    formData.append('UpdateContent', UpdateContent)
    formData.append('profolio', profolio)
    formData.append('tagUserID', tagUserID)
    formData.append('tagClassID', tagClassID)
    formData.append('tagLevelID', tagLevelID)

    const request = {
      url: `${API_HOST}/controller/Posting.asmx/updatePost`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async softDeletePost(postId, profolio) {
    const data = {
      postID: postId,
      profolio,
      actionStatus: 'Void',
    }

    return await this.callWebService('/controller/Posting.asmx/updatePost', data, 'POST')
  }

  async getApproverMaster() {
    const data = {}

    return await this.callWebService('/controller/Approver.asmx/getApproverMaster', data, 'POST')
  }

  async saveApproverMaster(approverLevel, approverUserID, approverType) {
    const data = {
      approverLevel: approverLevel,
      approverUserID: approverUserID,
      approverType: approverType,
    }

    return await this.callWebService('/controller/Approver.asmx/saveApproverMaster', data, 'POST')
  }

  async updateApproverMaster(approverMasterID, actionStatus) {
    const data = {
      approverMasterID: approverMasterID,
      actionStatus: actionStatus,
    }

    return await this.callWebService('/controller/Approver.asmx/updateApproverMaster', data, 'POST')
  }

  async getApproverMasterSpecificUser() {
    const data = {}

    return await this.callWebService('/controller/Approver.asmx/getApproverMasterSpecificUser', data, 'POST')
  }

  async updateApproverMasterSpecificUser(approverMasterSpecificID, actionStatus) {
    const data = {
      approverMasterSpecificID: approverMasterSpecificID,
      actionStatus: actionStatus,
    }

    return await this.callWebService('/controller/Approver.asmx/updateApproverMasterSpecificUser', data, 'POST')
  }

  async saveApproverMasterSpecificUser(neededApproveSpecificUserID, approverType) {
    const data = {
      neededApproveSpecificUserID: neededApproveSpecificUserID,
      approverType: approverType,
    }

    return await this.callWebService('/controller/Approver.asmx/saveApproverMasterSpecificUser', data, 'POST')
  }

  async getPendingApprover() {
    const data = {}

    return await this.callWebService('/controller/Approver.asmx/getPendingApprover', data, 'POST')
  }

  async checkApproveStatusByUser(itemID, mode) {
    const data = {
      itemID: itemID,
      mode: mode,
    }

    let result = await this.callWebService('/controller/Approver.asmx/checkApproveStatusByUser', data, 'POST')
    return result
  }

  async getCountryList() {
    // let response;
    // try {
    //     response = await fetch("http://local.emsv2/controller/Students.asmx/getCountryList");
    // } catch (err) {
    //     console.log(err);
    //     throw ERROR_SERVER_UNREACHABLE;
    // }
    // return await parseResponseAndHandleErrors(response);

    const data = {}

    return await this.callWebService('/controller/Students.asmx/getCountryList', data, 'POST')
  }

  async getCountryListwBlank() {
    // let response;
    // try {
    //     response = await fetch("http://local.emsv2/controller/Students.asmx/getCountryList");
    // } catch (err) {
    //     console.log(err);
    //     throw ERROR_SERVER_UNREACHABLE;
    // }
    // return await parseResponseAndHandleErrors(response);

    const data = {}

    return await this.callWebService('/controller/Students.asmx/getCountryListwBlank', data, 'POST')
  }

  async getLevel(customLevelNotEqual) {
    const data = {
      customLevelNotEqual: customLevelNotEqual,
    }
    return await this.callWebService('/controller/Course.asmx/getLevel', data, 'POST')
  }

  async getLevelAll(customLevelNotEqual) {
    const data = {
      customLevelNotEqual: customLevelNotEqual,
    }
    return await this.callWebService('/controller/Course.asmx/getLevelAll', data, 'POST')
  }

  async getClassLevel(courseID, schoolID) {
    const data = {
      courseID: courseID,
      schoolID: schoolID,
    }
    return await this.callWebService('/controller/Course.asmx/getLevelClass', data, 'POST')
  }

  async getLevelSpecificSchool(speificSchoolID) {
    const data = {
      speificSchoolID: speificSchoolID,
    }
    return await this.callWebService('/controller/Course.asmx/getLevel', data, 'POST')
  }

  async getStudentDropDownList(jsonString) {
    const data = {
      jsonString: jsonString,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentDropDownList', data, 'POST')
  }

  async getStudentEnrollment(passHowManyDaysStudentCreated) {
    const data = {
      passHowManyDaysStudentCreated: passHowManyDaysStudentCreated,
    }
    return await this.callWebService('/controller/Students.asmx/getNewEnrolmentBySchoolWithPastDay', data, 'POST')
  }

  async getWithdrawStudent(passHowManyDays) {
    const data = {
      passHowManyDays: passHowManyDays,
    }
    return await this.callWebService('/controller/Students.asmx/getWithdrawnBySchoolWithPastDay', data, 'POST')
  }

  async getTransferStudent(pastHowManyDays) {
    const data = {
      pastHowManyDays: pastHowManyDays,
    }
    return await this.callWebService('/controller/Students.asmx/getTransferBySchoolWithPastDay', data, 'POST')
  }

  async getAcademicYear() {
    const data = {}
    return await this.callWebService('/controller/Course.asmx/getAcademicYear', data, 'POST')
  }

  async getAcademicYearWithClosedPastYear() {
    const data = {}
    return await this.callWebService('/controller/Course.asmx/getAcademicYearWithClosedPastYear', data, 'POST')
  }

  async getAcademicYearforFourYears() {
    const data = {}
    return await this.callWebService('/controller/Course.asmx/getAcademicYearforFourYears', data, 'POST')
  }

  async getAcademicYearBySchoolID(customSchoolName) {
    const data = {
      customSchoolName: customSchoolName,
    }
    return await this.callWebService('/controller/Course.asmx/getAcademicYear', data, 'POST')
  }

  async getAllAcademicYears(customSchoolName) {
    const data = {
      customSchoolName: customSchoolName,
    }
    return await this.callWebService('/controller/Course.asmx/getAllAcademicYears', data, 'POST')
  }

  async getAllAcademicYearsByGroup(schoolGroup) {
    const data = {
      schoolGroup: schoolGroup,
    }
    return await this.callWebService('/controller/Course.asmx/getAllAcademicYearsByGroup', data, 'POST')
  }

  async getIntakeYear() {
    const data = {}
    return await this.callWebService('/controller/Students.asmx/getIntakeYear', data, 'POST')
  }

  // SAMPLE 2 using axios

  // POST SAMPLE

  async getAttendanceClass() {
    const data = {}
    return await this.callWebService('/controller/Attendance.asmx/getAttendanceClass', data, 'POST')
  }

  async getAttendanceClassWithMode(mode) {
    const data = {
      mode: mode,
    }
    return await this.callWebService('/controller/Attendance.asmx/getAttendanceClass', data, 'POST')
  }

  async LoadAttendanceList(classValue, statuses) {
    const data = {
      classValue: classValue,
      statuses: statuses,
    }
    return await this.callWebService('/controller/Attendance.asmx/LoadAttendanceList', data, 'POST')
  }

  async LoadAttendanceAudit(strStartDate, strEndDate, indexNo) {
    const data = {
      startDate: strStartDate,
      endDate: strEndDate,
      indexNo: indexNo,
    }

    return await this.callWebService('/controller/Attendance.asmx/LoadAttendanceAudit', data, 'POST')
  }

  async LoadAttendanceListWithMode(classValue, mode) {
    const data = {
      classValue: classValue,
      mode: mode,
    }
    return await this.callWebService('/controller/Attendance.asmx/LoadAttendanceList', data, 'POST')
  }

  async LoadAttendanceListWithDateMode(classValue, mode, loadDate) {
    const data = {
      classValue: classValue,
      mode: mode,
      loadDate: loadDate,
    }
    return await this.callWebService('/controller/Attendance.asmx/LoadAttendanceList', data, 'POST')
  }

  async updateAttendanceList(jsonString) {
    const data = {
      jsonString: jsonString,
    }
    return await this.callWebService('/controller/Attendance.asmx/updateAttendanceList', data, 'POST')
  }

  async updateAttendanceListWithDateMode(jsonString, loadDate) {
    console.log('here!!!', loadDate)
    const data = {
      jsonString: jsonString,
      loadDate: loadDate,
    }
    return await this.callWebService('/controller/Attendance.asmx/updateAttendanceList', data, 'POST')
  }

  //#region Gallery
  async getFiles(galFolderID, startRowNo, endRowNo, fileText) {
    const data = {
      galFolderID: galFolderID,
      startRowNo: startRowNo,
      endRowNo: endRowNo,
      fileRetrieveMode: 'File',
      fileText: fileText,
    }

    return await this.callWebService('/controller/Gallery.asmx/getFile', data, 'POST')
  }

  async getFolders(galFolderID) {
    const data = {
      galFolderID: galFolderID,
      fileRetrieveMode: 'Folder',
    }

    return await this.callWebService('/controller/Gallery.asmx/getFile', data, 'POST')
  }

  async downloadFile(galID) {
    const data = {
      galID: galID,
    }

    return await this.callWebService('/controller/Gallery.asmx/downloadFile', data, 'POST')
  }

  async saveFile(files, galFolderID) {
    const formData = new FormData()

    formData.append('fileType', 'File')
    formData.append('galFolderID', galFolderID)
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('folderName', '')

    if (files && files.length > 1) {
      for (let i = 0; i < files.length; i++) {
        formData.append('files' + i, files[i])
        // console.log(files[i], "more");
        formData.append('files' + i + '_FileText', files[i].FileText)
      }
    } else if (files /*&& files.length === 1*/) {
      formData.append('files', files[0])
      formData.append('files_FileText', files[0].FileText)
    }

    const request = {
      url: `${API_HOST}/controller/Gallery.asmx/saveFile`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async createFolder(galFolderID, folderName) {
    const formData = new FormData()

    formData.append('fileType', 'Folder')
    formData.append('galFolderID', galFolderID)
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('folderName', folderName)
    formData.append('files', null)

    const request = {
      url: `${API_HOST}/controller/Gallery.asmx/saveFile`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async removeFile(galID) {
    const data = {
      galID: galID,
      updateFileMode: 'Delete',
    }

    return await this.callWebService('/controller/Gallery.asmx/updateFile', data, 'POST')
  }

  async renameFile(galID, folderRename) {
    const data = {
      galID: galID,
      folderRename: folderRename,
      updateFileMode: 'Rename',
    }

    return await this.callWebService('/controller/Gallery.asmx/updateFile', data, 'POST')
  }

  async moveFile(galID, galFolderID) {
    const data = {
      galID: galID,
      galFolderID: galFolderID,
      updateFileMode: 'Move',
    }

    return await this.callWebService('/controller/Gallery.asmx/updateFile', data, 'POST')
  }

  async getWhitelist() {
    const data = {}
    return await this.callWebService('/controller/Gallery.asmx/getWhitelistFileExt', data, 'POST')
  }

  //#endregion

  /*#region Portfolio*/
  async updatePortfolio(portfolioID, actionStatus) {
    const data = {
      portfolioID: portfolioID,
      actionStatus: actionStatus,
    }

    return await this.callWebService('/controller/Portfolio.asmx/updatePortfolio', data, 'POST')
  }

  async getPortfolioListByStudentID(str_StudentID) {
    const data = { studentID: str_StudentID }

    return await this.callWebService('/controller/Portfolio.asmx/getPortfolioList', data, 'POST')
  }

  async getPortfolioHeaderDetails(portfolioID, byPassToken) {
    const data = { portfolioID: portfolioID, byPassToken: byPassToken }

    return await this.callWebService('/controller/Portfolio.asmx/getPortfolioHeaderDetails', data, 'POST')
  }

  async getStudentPostByType(str_StudentID, str_PostType, numberOfPost, lastPostID, mode) {
    const data = {
      studentID: str_StudentID,
      postType: str_PostType,
      numberOfPost: numberOfPost,
      lastPostID: lastPostID,
      mode: mode,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostStudent', data, 'POST')
  }

  async approvePortfolio(portfolioID, actionStatus, jsonHeaderComment, jsonPostComment) {
    const data = {
      portfolioID: portfolioID,
      actionStatus: actionStatus,
      jsonHeaderComment: jsonHeaderComment,
      jsonPostComment: jsonPostComment,
    }

    let result = await this.callWebService('/controller/Portfolio.asmx/approvePortfolio', data, 'POST')
    return result
  }

  async getApproverComment(itemID) {
    const data = {
      itemID: itemID,
    }

    let result = await this.callWebService('/controller/Approver.asmx/getApproverComment', data, 'POST')
    return result
  }

  /*#endregion*/

  /*#region Promotion*/

  async getClassByLevelClassID(str_LevelID, str_ClassID) {
    const data = { levelID: str_LevelID, classID: str_ClassID }

    return await this.callWebService('/controller/Operations.asmx/getMassPromotionsStudentListByClassLevel', data, 'POST')
  }

  async getClassByAcademicYear(str_AcademicYearID) {
    const data = { academicYearID: str_AcademicYearID }

    return await this.callWebService('/controller/Operations.asmx/getMassPromotionsClassLevelByAcademicYear', data, 'POST')
  }

  async getClassBySemesterAndCourseID(academicYear, courseID) {
    const data = {
      academicYear: academicYear,
      courseID: courseID,
    }

    return await this.callWebService('/controller/Course.asmx/getClass', data, 'POST')
  }

  async getNextLevel(str_LevelID) {
    const data = { levelID: str_LevelID }

    return await this.callWebService('/controller/Operations.asmx/getMassPromotionsNextLevel', data, 'POST')
  }

  // studentIDArray (student id split by comma ",") & levelID & academicYearID & classID
  async saveStudentPromotions(arrstr_StudentID, str_AcademicYearID, str_LevelID, str_ClassID) {
    const data = {
      studentIDArray: arrstr_StudentID,
      academicYearID: str_AcademicYearID,
      levelID: str_LevelID,
      classID: str_ClassID,
    }

    return await this.callWebService('/controller/Operations.asmx/saveMassPromotions', data, 'POST')
  }

  async getAllActiveStudentsBySchool() {
    const data = {}

    return await this.callWebService('/controller/Students.asmx/getAllActiveStudentsBySchool', data, 'POST')
  }

  async getAllActiveStudentsBySchoolWithMode(mode) {
    const data = {
      mode: mode,
    }

    return await this.callWebService('/controller/Students.asmx/getAllActiveStudentsBySchool', data, 'POST')
  }

  /*#endregion*/

  /*#region Report*/

  async getReportListByStudentID(str_StudentID) {
    const data = { studentID: str_StudentID }

    return await this.callWebService('/controller/Report.asmx/getReportList', data, 'POST')
  }

  async saveReport(str_ReportDesc, str_StudentID, arrstr_PostID, ReportLinkReportID) {
    const data = {
      reportDesc: str_ReportDesc,
      studentID: str_StudentID,
      jsonStringPostID: arrstr_PostID,
      ReportLinkReportID: ReportLinkReportID,
    }

    return await this.callWebService('/controller/Report.asmx/saveReport', data, 'POST')
  }

  async getPostByReportID(str_ReportID) {
    const data = { reportID: str_ReportID }

    return await this.callWebService('/controller/Report.asmx/getReport', data, 'POST')
  }

  async softDeleteReport(arrstr_ReportID) {
    const data = {
      jsonStringReportID: arrstr_ReportID,
      actionStatus: 'VOID',
    }

    return await this.callWebService('/controller/Report.asmx/updateReport', data, 'POST')
  }

  /*#endregion*/

  /*#region Reactions*/
  async getPostReaction(relatedPostID) {
    const data = { relatedPostID: relatedPostID }

    return await this.callWebService('/controller/Posting.asmx/getPostReaction', data, 'POST')
  }

  async savePostReaction(relatedPostID, postReaction, postType) {
    const data = {
      relatedPostID: relatedPostID,
      postReaction: postReaction,
      postType: postType,
    }

    return await this.callWebService('/controller/Posting.asmx/savePostReaction', data, 'POST')
  }

  async updatePostReaction(relatedPostID, actionMode) {
    const data = {
      relatedPostID: relatedPostID,
      actionMode: actionMode,
    }

    return await this.callWebService('/controller/Posting.asmx/updatePostReaction', data, 'POST')
  }

  async getPostByPostID(jsonStringPostID) {
    const data = {
      jsonStringPostID: jsonStringPostID,
    }

    return await this.callWebService('/controller/Posting.asmx/getPostByPostID', data, 'POST')
  }

  async getPostByPostIDByStatus(jsonStringPostID, postStatus) {
    const data = {
      jsonStringPostID: jsonStringPostID,
      postStatus: postStatus,
    }

    return await this.callWebService('/controller/Posting.asmx/getPostByPostID', data, 'POST')
  }

  /*#endregion*/

  async getAllActiveStudentsByClass(classID) {
    const data = { classID: classID }

    return await this.callWebService('/controller/Students.asmx/getAllActiveStudentsByClassSchool', data, 'POST')
  }

  async getDailyRoutineByStudentID(studentID) {
    const data = { studentID: studentID }

    return await this.callWebService('/controller/Daily_Routine.asmx/getKgm_DailyRoutine', data, 'POST')
  }

  async updateDailyRoutine(btnUpdateObject) {
    const data = {
      studentID: btnUpdateObject.studentID,
      DrID: btnUpdateObject.drID,
      drRemark: btnUpdateObject.drRemark,
    }
    return await this.callWebService('/controller/Daily_Routine.asmx/updateDailyRoutine', data, 'POST')
  }

  async addDailyRoutine(btnAddObject) {
    const data = {
      studentIDArray: btnAddObject.studentIDArray,
      drRemark: btnAddObject.DrRemark,
      drStartTime: btnAddObject.DrStartTime,
      drEndTime: btnAddObject.DrEndTime,
      drReferenceType: btnAddObject.DrReferenceType,
    }

    return await this.callWebService('/controller/Daily_Routine.asmx/addDailyRoutine', data, 'POST')
  }

  async deleteDailyRoutine(btnDelObject) {
    const data = {
      studentID: btnDelObject.DrStudentID,
      DrID: btnDelObject.drID,
    }
    return await this.callWebService('/controller/Daily_Routine.asmx/deleteDailyRoutine', data, 'POST')
  }

  async deString(inputString) {
    const data = {
      inputString: inputString,
    }
    return await this.callWebService('/controller/Login.asmx/deString', data, 'POST')
  }

  async getStaffProfileImage() {
    const data = {}
    return await this.callWebService('/controller/User.asmx/getStaffProfileImage', data, 'POST')
  }

  async saveStaffProfileImage(files) {
    const data = new FormData()
    data.append('token', Cookies.get('authToken'))
    data.append('UserSchool_Session', Cookies.get('schoolSession'))
    data.append('UserID_Session', Cookies.get('userIDSession'))
    data.append('UserUniversity_Session', Cookies.get('userUniversitySession'))

    if (files && files.length > 1) {
      for (let key in files) {
        //console.log(key);
        if (files.hasOwnProperty(key)) {
          // console.log(files[key]);
          if (key > 0) {
            data.append(`upload_${key}`, files[key])
          } else {
            data.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      data.append('upload', files[0])
    }

    const request = {
      url: `${API_HOST}/controller/User.asmx/saveStaffProfileImage`,
      cache: false,
      type: 'POST',
      data: data,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async resetPasswordByPassword(userCurrentPassword, userNewPassword) {
    const data = {
      userCurrentPassword: userCurrentPassword,
      userNewPassword: userNewPassword,
    }
    return await this.callWebService('/controller/Login.asmx/resetPasswordByPassword', data, 'POST')
  }

  async getAllActiveSchool(schoolCountry, universityCode) {
    const data = {
      schoolCountry: schoolCountry,
      universityCode: universityCode,
    }
    return await this.callWebService('/controller/Operations.asmx/getAllActiveSchool', data, 'POST')
  }

  async saveTransferSchoolAllowToday(studentID, toTransferSchoolID, remark, effectiveDate, referralTransfer) {
    const data = {
      studentID: studentID,
      toTransferSchoolID: toTransferSchoolID,
      remark: remark,
      effectiveDate: effectiveDate,
      referralTransfer: referralTransfer,
    }
    return await this.callWebService('/controller/Students.asmx/saveTransferSchoolAllowToday', data, 'POST')
  }

  async getPendingAcceptTransferSchoolBySchool() {
    const data = {}
    return await this.callWebService('/controller/Students.asmx/getPendingAcceptTransferSchoolBySchool', data, 'POST')
  }

  async getClassType(filter_school = null) {
    const data = { filter_school: filter_school }
    return await this.callWebService('/controller/Class.asmx/getClassType', data, 'POST')
  }

  async getTeacherListBySchool() {
    const data = {}
    return await this.callWebService('/controller/User.asmx/getTeacherListBySchool', data, 'POST')
  }

  async getTeacherPrinListBySchool() {
    const data = {}
    return await this.callWebService('/controller/User.asmx/getTeacherPrinListBySchool', data, 'POST')
  }

  getFeedFilterSemesterList() {
    return this.callWebService('/controller/Api.asmx/GetFilterSemesterList', {}, 'POST')
  }

  getFeedFilterLevelList() {
    return this.callWebService('/controller/Api.asmx/GetFilterLevelList', {}, 'POST')
  }

  getFeedFilterClassList() {
    return this.callWebService('/controller/Api.asmx/GetFilterClassList', {}, 'POST')
  }

  getFeedFilterTeacherList() {
    return this.callWebService('/controller/Api.asmx/GetFilterTeacherList', {}, 'POST')
  }

  GetAlumniReport(dateRange, schoolID) {
    const data = {
      dateRange: dateRange,
      schoolID: schoolID,
    }
    return this.callWebService('/controller/Api.asmx/GetAlumniReport', data, 'POST')
  }

  GetSchoolFeeReport1(school, academicyear) {
    const data = {
      school: school,
      academicyear: academicyear,
    }
    return this.callWebService('/controller/Api.asmx/GetSchoolFeeReport1', data, 'POST')
  }

  GetSchoolFeeReport2(school, academicyear) {
    const data = {
      school: school,
      academicyear: academicyear,
    }
    return this.callWebService('/controller/Api.asmx/GetSchoolFeeReport2', data, 'POST')
  }

  GetSchoolFeeReportManualMovement_Withdrawal(school, academicyear) {
    const data = {
      school: school,
      academicyear: academicyear,
    }
    return this.callWebService('/controller/Api.asmx/GetSchoolFeeReportManualMovement_Withdrawal', data, 'POST')
  }

  GetGroupSchoolFeeReport1(school, academicyear) {
    const data = {
      school: school,
      academicyear: academicyear,
    }
    return this.callWebService('/controller/Api.asmx/GetGroupSchoolFeeReport1', data, 'POST')
  }

  GetGroupSchoolFeeReport2(school, academicyear) {
    const data = {
      school: school,
      academicyear: academicyear,
    }
    return this.callWebService('/controller/Api.asmx/GetGroupSchoolFeeReport2', data, 'POST')
  }

  GetAlumniRelationshipReport(dateRange, schoolID) {
    const data = {
      dateRange: dateRange,
      schoolID: schoolID,
    }
    return this.callWebService('/controller/Api.asmx/GetAlumniRelationshipReport', data, 'POST')
  }

  GetParentsEmail(studentID) {
    const data = {
      studentID: studentID,
    }
    return this.callWebService('/controller/Api.asmx/GetParentsEmail', data, 'POST')
  }

  ClassTransferGoals(crsID, fromClassID, toClassID, semID) {
    const data = {
      crsID: crsID,
      fromClassID: fromClassID,
      toClassID: toClassID,
      semID: semID,
    }
    return this.callWebService('/controller/Api.asmx/ClassTransferGoals', data, 'POST')
  }

  async GetFinanceNotificationEmailList(schoolID) {
    const data = {
      schoolID: schoolID,
    }
    return this.callWebService('/controller/Api.asmx/GetFinanceNotificationEmailList', data, 'POST')
  }

  async SaveFinanceNotificationEmailList(SchoolId, EmailTo, EmailCC, EmailBCC) {
    const data = {
      SchoolId: SchoolId,
      EmailTo: EmailTo,
      EmailCC: EmailCC,
      EmailBCC: EmailBCC,
    }
    return this.callWebService('/controller/Api.asmx/SaveFinanceNotificationEmailList', data, 'POST')
  }

  async saveClass(levelID, semesterID, batch, className, maxStudents, classTeacher, saveType, classAssitantTeacherID) {
    const data = {
      levelID: levelID,
      semesterID: semesterID,
      batch: batch,
      className: className,
      maxStudents: maxStudents,
      classTeacher: classTeacher,
      saveType: saveType,
      classAssitantTeacherID: classAssitantTeacherID,
    }
    return await this.callWebService('/controller/Class.asmx/saveClass', data, 'POST')
  }

  async getClass(academicYear) {
    const data = {
      academicYear: academicYear,
    }
    return await this.callWebService('/controller/Course.asmx/getClass', data, 'POST')
  }

  async getClassIncludeClosed(academicYear) {
    const data = {
      academicYear: academicYear,
    }
    return await this.callWebService('/controller/Course.asmx/getClassIncludeClosed', data, 'POST')
  }

  async getClassByLevel(courseID) {
    const data = {
      courseID: courseID,
    }
    return await this.callWebService('/controller/Course.asmx/getClass', data, 'POST')
  }

  async getStudentByCourseClassType(CourseID, ClassID, StudentType) {
    const data = {
      CourseID: CourseID,
      ClassID: ClassID,
      StudentType: StudentType,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentByCourseClassType', data, 'POST')
  }

  async getParentClassList(academicYear, modeType) {
    const data = {
      academicYear: academicYear,
      modeType: modeType,
    }
    return await this.callWebService('/controller/Course.asmx/getClass', data, 'POST')
  }

  async updateClass(classStatus, newClassName, maxStudents, currentClassName, levelID, semesterID, classTeacherID, classAssitantTeacherID, classID) {
    const data = {
      classStatus: classStatus,
      newClassName: newClassName,
      maxStudents: maxStudents,
      currentClassName: currentClassName,
      levelID: levelID,
      semesterID: semesterID,
      classTeacherID: classTeacherID,
      classAssitantTeacherID: classAssitantTeacherID,
      // Scopes the edit to this specific class/batch row. Without it the
      // backend falls back to resolving every class sharing this name,
      // which can span multiple batches (e.g. Full Day / Half Day).
      classID: classID,
    }
    return await this.callWebService('/controller/Class.asmx/updateClass', data, 'POST')
  }

  async updateClassProgramme(classID, classStatus) {
    const data = {
      classID: classID,
      classStatus: classStatus,
    }
    return await this.callWebService('/controller/Class.asmx/updateClassProgramme', data, 'POST')
  }

  async getActiveStudentsByLevelSchool(levelID, classID, semID, includePendingStatus, filterClassScheduleDate) {
    const data = {
      levelID: levelID,
      classID: classID,
      semID: semID,
      includePendingStatus: includePendingStatus,
      filterClassScheduleDate: filterClassScheduleDate,
    }
    return await this.callWebService('/controller/Students.asmx/getActiveStudentsByLevelSchool', data, 'POST')
  }

  async saveStudentGraduation(obj) {
    const data = {
      obj: obj,
    }
    return await this.callWebService('/controller/Students.asmx/saveStudentGraduation', data, 'POST')
  }

  async saveStudentDocument(files, studentID, fileDescription, uploadMode, parFolder) {
    const data = new FormData()
    data.append('token', Cookies.get('authToken'))
    data.append('UserSchool_Session', Cookies.get('schoolSession'))
    data.append('UserID_Session', Cookies.get('userIDSession'))
    data.append('UserUniversity_Session', Cookies.get('userUniversitySession'))

    if (files && files.length > 1) {
      for (let key in files) {
        //console.log(key);
        if (files.hasOwnProperty(key)) {
          // console.log(files[key]);
          if (key > 0) {
            data.append(`upload_${key}`, files[key])
          } else {
            data.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      data.append('upload', files[0])
    }

    data.append('studentID', studentID)
    data.append('fileDescription', fileDescription)
    data.append('uploadMode', uploadMode)
    data.append('parFolder', parFolder)

    const request = {
      url: `${API_HOST}/controller/Students.asmx/saveStudentDocument`,
      cache: false,
      type: 'POST',
      data: data,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async getStudentDocument(studentID, docType, parFolder) {
    const data = {
      studentID: studentID,
      docType: docType,
      parFolder: parFolder,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentDocument', data, 'POST')
  }

  async getStudentDocumentBase64String(studentFilesID) {
    const data = {
      studentFilesID: studentFilesID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentDocumentBase64String', data, 'POST')
  }

  async updateStudentDocument(studentFilesID, actionStatus) {
    const data = {
      studentFilesID: studentFilesID,
      actionStatus: actionStatus,
    }
    return await this.callWebService('/controller/Students.asmx/updateStudentDocument', data, 'POST')
  }

  async getSchoolInfoBySchoolID(schoolID) {
    const data = {
      schoolID: schoolID,
    }
    return await this.callWebService('/controller/User.asmx/getSchoolInfoBySchoolID', data, 'POST')
  }

  async getStudentAllergies(studentID, allergiesType) {
    const data = {
      studentID: studentID,
      allergiesType: allergiesType,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentAllergies', data, 'POST')
  }

  async getPaymentList(studentCourseID, studentID) {
    const data = {
      studentCourseID: studentCourseID,
      studentID: studentID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentList', data, 'POST')
  }

  async getItemTransDetailsList(SPDID) {
    const data = {
      SPDID: SPDID,
    }
    return await this.callWebService('/controller/Billing.asmx/getItemTransDetailsList', data, 'POST')
  }

  async saveEvent(files, obj, participantObj) {
    const formData = new FormData()
    formData.append('obj', obj)
    formData.append('ParticipantObj', participantObj)
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('UserType_Session', Cookies.get('userTypeSession'))
    formData.append('UserUniversitySession', Cookies.get('userUniversitySession'))
    formData.append('UserEmailSession', Cookies.get('userEmailSession'))
    formData.append('USRidSession', Cookies.get('usRidSession'))
    formData.append('UserNameSession', Cookies.get('userNameSession'))
    console.log(files, 'files')
    if (files && files.length > 1) {
      for (let key in files) {
        if (files.hasOwnProperty(key)) {
          if (key > 0) {
            formData.append(`upload_${key}`, files[key])
          } else {
            formData.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      formData.append('upload', files[0])
    }
    const request = {
      url: `${API_HOST}/controller/Event.asmx/saveEvent`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }
    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async getEvent(dateFrom, dateTo) {
    const data = {
      dateFrom: dateFrom,
      dateTo: dateTo,
    }
    return await this.callWebService('/controller/Event.asmx/getEventList', data, 'POST')
  }

  async getEventDetails(eventID) {
    const data = {
      eventID: eventID,
    }
    return await this.callWebService('/controller/Event.asmx/getEventDetails', data, 'POST')
  }

  async getPublicRegistrationDetails(encryptedEventParID) {
    const data = {
      encryptedEventParID: encryptedEventParID,
    }
    return await this.callWebService('/controller/Event.asmx/getPublicRegistrationDetails', data, 'POST')
  }

  async getEventFile(eventID) {
    const data = {
      eventID: eventID,
    }
    return await this.callWebService('/controller/Event.asmx/getEventFiles', data, 'POST')
  }

  async getUpComingEvent() {
    const data = {}
    return await this.callWebService('/controller/Event.asmx/getLatestUpComingEvents', data, 'POST')
  }

  async getUpComingEventDetail(obj) {
    const data = {
      obj: obj,
    }
    return await this.callWebService('/controller/Event.asmx/getUpComingEventDetail', data, 'POST')
  }

  async getEventParticipantByEventID(eventID) {
    const data = {
      eventID: eventID,
    }
    return await this.callWebService('/controller/Event.asmx/getEventParticipantList', data, 'POST')
  }

  async saveEventRegistration(eventID, ParticipantObj) {
    const data = {
      eventID: eventID,
      ParticipantObj: ParticipantObj,
    }
    return await this.callWebService('/controller/Event.asmx/saveEventRegistration', data, 'POST')
  }

  async savePublicRegistration(encryptedEventParID, action) {
    const data = {
      encryptedEventParID: encryptedEventParID,
      action: action,
    }
    return await this.callWebService('/controller/Event.asmx/savePublicRegistration', data, 'POST')
  }

  async updateEvent(files, obj, participantObj) {
    const formData = new FormData()
    formData.append('Obj', obj)
    formData.append('ParticipantObj', participantObj)
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('UserType_Session', Cookies.get('userTypeSession'))
    formData.append('UserUniversitySession', Cookies.get('userUniversitySession'))
    formData.append('UserEmailSession', Cookies.get('userEmailSession'))
    formData.append('USRidSession', Cookies.get('usRidSession'))
    formData.append('UserNameSession', Cookies.get('userNameSession'))

    if (files && files.length > 1) {
      for (let key in files) {
        if (files.hasOwnProperty(key)) {
          if (key > 0) {
            formData.append(`upload_${key}`, files[key])
          } else {
            formData.append('upload', files[key])
          }
        }
      }
    } else if (files && files[0]) {
      formData.append('upload', files[0])
    }

    console.log('files')
    console.log(files)

    const request = {
      url: `${API_HOST}/controller/Event.asmx/updateEvent`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async deleteEvent(eventID /*, SendEmailFlag*/) {
    const data = {
      eventID: eventID,
    }
    return await this.callWebService('/controller/Event.asmx/deleteEvent', data, 'POST')
  }

  async sendEvent(eventID, Obj) {
    const data = {
      eventID: eventID,
      Obj: Obj,
    }
    return await this.callWebService('/controller/Event.asmx/sendEventEmail', data, 'POST')
  }

  async getStudentGraduationListByClassLevel(str_LevelID, str_ClassID) {
    const data = { levelID: str_LevelID, classID: str_ClassID }

    return await this.callWebService('/controller/Students.asmx/getStudentGraduationListByClassLevel', data, 'POST')
  }

  async getClassStudentList(academicYearID, levelID, className) {
    const data = {
      academicYearID: academicYearID,
      levelID: levelID,
      className: className,
    }

    return await this.callWebService('/controller/Course.asmx/getClassStudentList', data, 'POST')
  }

  async getStudentProjectedBySchool() {
    const data = {}
    return await this.callWebService('/controller/Students.asmx/getStudentProjectedBySchool', data, 'POST')
  }

  async getStudentsMovementLastAndCurrentYear() {
    const data = {}
    return await this.callWebService('/controller/Students.asmx/getStudentsMovementLastAndCurrentYear', data, 'POST')
  }

  async getBusMasterList(type) {
    const data = {
      type: type,
    }
    return await this.callWebService('/controller/Attendance.asmx/getBusMasterList', data, 'POST')
  }

  async saveBusMasterList(busNo, type) {
    const data = {
      busNo: busNo,
      type: type,
    }
    return await this.callWebService('/controller/Attendance.asmx/saveBusMasterList', data, 'POST')
  }

  async updateBusMasterList(busID, busStatus) {
    const data = {
      busID: busID,
      busStatus: busStatus,
    }
    return await this.callWebService('/controller/Attendance.asmx/updateBusMasterList', data, 'POST')
  }

  async getActiveStudentListBySchoolIDOfBusNo(busID, type) {
    const data = {
      busID: busID,
      type: type,
    }

    return await this.callWebService('/controller/Attendance.asmx/getActiveStudentListBySchoolIDOfBusNo', data, 'POST')
  }

  async updateStudentBusNo(jsonString, status) {
    const data = {
      jsonString: jsonString,
      status: status,
    }

    return await this.callWebService('/controller/Attendance.asmx/updateStudentBusNo', data, 'POST')
  }

  async LoadBusAttendanceList(busID) {
    const data = {
      busID: busID,
    }

    return await this.callWebService('/controller/Attendance.asmx/LoadBusAttendanceList', data, 'POST')
  }

  async updateBusAttendanceList(jsonString) {
    const data = {
      jsonString: jsonString,
    }

    return await this.callWebService('/controller/Attendance.asmx/updateBusAttendanceList', data, 'POST')
  }

  async deletePaymentItem(SPDID, paymentPlanDetailID, studentCourseID) {
    const data = {
      SPDID: SPDID,
      paymentPlanDetailID: paymentPlanDetailID,
      studentCourseID: studentCourseID,
    }
    return await this.callWebService('/controller/Billing.asmx/deletePaymentItem', data, 'POST')
  }

  async getCurrencyValueDropdownlist() {
    const data = {}
    return await this.callWebService('/controller/Billing.asmx/getCurrencyValueDropdownlist', data, 'POST')
  }

  async saveItem(btnAddItemObject) {
    const data = {
      SPPD_FK_Student_Course_ID: btnAddItemObject.SPPD_FK_Student_Course_ID,
      SPPD_PayerName: btnAddItemObject.SPPD_PayerName,
      SPPD_PaymentSchedule: btnAddItemObject.SPPD_PaymentSchedule,
      SPPD_PaymentItemType: btnAddItemObject.SPPD_PaymentItemType,
      SPPD_Currency: btnAddItemObject.SPPD_Currency,
      SPPD_PaymentAmount: btnAddItemObject.SPPD_PaymentAmount,
      SPPD_PaymentDate: btnAddItemObject.SPPD_PaymentDate,
      noOfRecurring: btnAddItemObject.noOfRecurring,
      itemDescription: btnAddItemObject.itemDescription,
      itemFromDate: btnAddItemObject.itemFromDate,
      itemToDate: btnAddItemObject.itemToDate,
    }
    return await this.callWebService('/controller/Billing.asmx/saveItem', data, 'POST')
  }

  async getPaymentPlanMasterList(studentCourseID) {
    const data = {
      studentCourseID: studentCourseID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentPlanMasterList', data, 'POST')
  }

  async getPaymentPlanRules(studentCourseID, jsonString) {
    const data = {
      studentCourseID: studentCourseID,
      jsonString: jsonString,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentPlanRules', data, 'POST')
  }

  async checkRateFeeEligible(studentID, studentCourseID, rateFeeMode) {
    const data = {
      studentID: studentID,
      studentCourseID: studentCourseID,
      rateFeeMode: rateFeeMode,
    }
    return await this.callWebService('/controller/Billing.asmx/checkRateFeeEligible', data, 'POST')
  }

  async getPaymentPlanLevelStartDate(studentCourseID) {
    const data = {
      studentCourseID: studentCourseID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentPlanLevelStartDate', data, 'POST')
  }

  async getPaymentPlanRuleDetails(paymentPlanRuleID) {
    const data = {
      paymentPlanRuleID: paymentPlanRuleID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentPlanRuleDetails', data, 'POST')
  }

  async checkSiblingDiscountEligible(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Billing.asmx/checkSiblingDiscountEligible', data, 'POST')
  }

  async getSiblingList(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Billing.asmx/getSiblingList', data, 'POST')
  }

  async getPaymentPlanMasterDetails(courseFeeSchemeID) {
    const data = {
      courseFeeSchemeID: courseFeeSchemeID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentPlanMasterDetails', data, 'POST')
  }

  async getPaymentPlanMasterDetailsList(courseFeeSchemeID) {
    const data = {
      courseFeeSchemeID: courseFeeSchemeID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentPlanMasterDetailsList', data, 'POST')
  }

  async getStudentCourseSemesterInfo(studentID, studentCourseID) {
    const data = {
      studentID: studentID,
      studentCourseID: studentCourseID,
    }
    return await this.callWebService('/controller/Course.asmx/getStudentCourseSemesterInfo', data, 'POST')
  }

  async savePaymentPlan(btnAddPaymentPlanObject) {
    const data = {
      btnAddPaymentPlanObject: btnAddPaymentPlanObject,
    }
    return await this.callWebService('/controller/Billing.asmx/savePaymentPlan', data, 'POST')
  }

  async checkStaffDiscountEligible(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Billing.asmx/checkStaffDiscountEligible', data, 'POST')
  }

  async getPaymentPlanStaffRules(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentPlanStaffRules', data, 'POST')
  }

  async getUserDetails(conID) {
    const data = {
      conID: conID,
    }
    return await this.callWebService('/controller/User.asmx/getUserDetails', data, 'POST')
  }

  async checkStudentPaymentPlan(studentCourseID) {
    const data = {
      studentCourseID: studentCourseID,
    }
    return await this.callWebService('/controller/Billing.asmx/checkStudentPaymentPlan', data, 'POST')
  }

  async savePaymentPlanDiscount(obj) {
    const data = {
      obj: obj,
    }
    return await this.callWebService('/controller/Billing.asmx/savePaymentPlanDiscount', data, 'POST')
  }

  async generateInvoice(obj, studentID, studentCourseID, inputPaymentDueDate, inputRemarks, action, invoiceName, isRefundRebate, refundRebateobj, gstRate) {
    const data = {
      obj: obj,
      studentID: studentID,
      studentCourseID: studentCourseID,
      inputPaymentDueDate: inputPaymentDueDate,
      inputRemarks: inputRemarks,
      action: action,
      invoiceName: invoiceName,
      isRefundRebate: isRefundRebate,
      refundRebateobj: refundRebateobj,
      GstPercentage: gstRate,
    }
    return await this.callWebService('/controller/Billing.asmx/generateInvoice', data, 'POST')
  }

  async getReInvoice(studentID, studentCourseID, invoiceName) {
    const data = {
      studentID: studentID,
      studentCourseID: studentCourseID,
      invoiceName: invoiceName,
    }
    return await this.callWebService('/controller/Billing.asmx/getReinvoiceActiveList', data, 'POST')
  }

  async generateReceipt(obj, studentID, studentCourseID, action, gstRate) {
    let data
    if (gstRate) {
      data = {
        obj: obj,
        studentID: studentID,
        studentCourseID: studentCourseID,
        action: action,
        GstPercentage: gstRate,
      }
    } else {
      data = {
        obj: obj,
        studentID: studentID,
        studentCourseID: studentCourseID,
        action: action,
      }
    }
    return await this.callWebService('/controller/Billing.asmx/generateReceipt', data, 'POST')
  }

  async getReceiptWithTransactionHistory(Obj, studentID, invoiceName) {
    const data = {
      receiptNameListObj: Obj,
      studentID: studentID,
      invoiceName: invoiceName,
    }
    return await this.callWebService('/controller/Billing.asmx/getTransactionHistoryList', data, 'POST')
  }

  async getStudentSchoolFeeRebate(studentID, checkRebateExist, rebateDesc) {
    const data = {
      studentID: studentID,
      checkRebateExist: checkRebateExist,
      rebateDesc: rebateDesc,
    }
    return await this.callWebService('/controller/Billing.asmx/getStudentSchoolFeeRebate', data, 'POST')
  }

  async tagRebateSchoolFeesToInvoice(PK_Invoice_ID, RebatePKInvoiceID) {
    const data = {
      PK_Invoice_ID: PK_Invoice_ID,
      RebatePKInvoiceID: RebatePKInvoiceID,
    }
    return await this.callWebService('/controller/Billing.asmx/tagRebateSchoolFeesToInvoice', data, 'POST')
  }

  async getLeftOverPaymentReceipt(Obj, studentID, invoiceName, studentCourseID, action) {
    const data = {
      receiptNameListObj: Obj,
      studentID: studentID,
      invoiceName: invoiceName,
      studentCourseID: studentCourseID,
      action: action,
    }
    return await this.callWebService('/controller/Billing.asmx/getLeftoverPayment', data, 'POST')
  }

  async getActivePaymentNoTransactionHistoryList(studentCourseID, value) {
    const data = {
      studentCourseID: studentCourseID,
      transType: value,
    }
    return await this.callWebService('/controller/Billing.asmx/getActivePaymentNoTransactionHistoryList', data, 'POST')
  }

  async generateCN(obj, isfullCN) {
    const data = {
      obj: obj,
      fullCN: isfullCN,
    }
    return await this.callWebService('/controller/Billing.asmx/generateCN', data, 'POST')
  }

  async getTransactionDocumentPdf(documentType, invRecID) {
    const data = {
      DocumentType: documentType,
      InvRecID: invRecID,
    }
    return await this.callWebService('/controller/Billing.asmx/getTransactionDocument', data, 'POST')
  }

  async updateAttendanceListWithTemperature(deviceOutput) {
    const data = {
      deviceOutput: deviceOutput,
    }

    return await this.callWebService('/controller/Attendance.asmx/updateAttendanceListWithTemperature', data, 'POST')
  }

  async getNumberOfAttendanceAllClassBySchool() {
    const data = {}

    return await this.callWebService('/controller/Attendance.asmx/getNumberOfAttendanceAllClassBySchool', data, 'POST')
  }

  async getEcaMasterList() {
    const data = {}

    return await this.callWebService('/controller/Attendance.asmx/getEcaMasterList', data, 'POST')
  }

  async saveEcaMasterList(ecaName) {
    const data = {
      ecaName: ecaName,
    }

    return await this.callWebService('/controller/Attendance.asmx/saveEcaMasterList', data, 'POST')
  }

  async updateEcaMasterList(ecaID, ecaStatus) {
    const data = {
      ecaID: ecaID,
      ecaStatus: ecaStatus,
    }

    return await this.callWebService('/controller/Attendance.asmx/updateEcaMasterList', data, 'POST')
  }

  async getEcaDetails(ecaID, EcaDtlDateAttend) {
    const data = {
      ecaID: ecaID,
      EcaDtlDateAttend: EcaDtlDateAttend,
    }

    return await this.callWebService('/controller/Attendance.asmx/getEcaDetails', data, 'POST')
  }

  async getEcaDetailsUnAssignStudent(ecaID, ecaDtlDateAttend) {
    const data = {
      ecaID: ecaID,
      ecaDtlDateAttend: ecaDtlDateAttend,
    }

    return await this.callWebService('/controller/Attendance.asmx/getEcaDetailsUnAssignStudent', data, 'POST')
  }

  async getEcaSummaryGroupByEcaID(ecaID) {
    const data = {
      ecaID: ecaID,
    }

    return await this.callWebService('/controller/Attendance.asmx/getEcaSummaryGroupByEcaID', data, 'POST')
  }

  async saveEcaDetails(jsonString, mode) {
    const data = {
      jsonString: jsonString,
      mode: mode,
    }

    return await this.callWebService('/controller/Attendance.asmx/saveEcaDetails', data, 'POST')
  }

  async updateEcaDetails(ecaDtlID, ecaDtlStatus) {
    const data = {
      ecaDtlID: ecaDtlID,
      ecaDtlStatus: ecaDtlStatus,
    }

    return await this.callWebService('/controller/Attendance.asmx/updateEcaDetails', data, 'POST')
  }

  async getEcaBySchoolIDDate(dateAttend) {
    const data = {
      dateAttend: dateAttend,
    }

    return await this.callWebService('/controller/Attendance.asmx/getEcaBySchoolIDDate', data, 'POST')
  }

  async LoadEcaAttendanceList(ecaID) {
    const data = {
      ecaID: ecaID,
    }

    return await this.callWebService('/controller/Attendance.asmx/LoadEcaAttendanceList', data, 'POST')
  }

  async updateEcaAttendanceList(jsonString) {
    const data = {
      jsonString: jsonString,
    }

    return await this.callWebService('/controller/Attendance.asmx/updateEcaAttendanceList', data, 'POST')
  }

  async generateEcaAttendanceReport(jsonString) {
    const data = {
      jsonString: jsonString,
    }

    return await this.callWebService('/controller/Attendance.asmx/generateEcaAttendanceReport', data, 'POST')
  }

  async getReceiptList(invoiceName, receiptName, receiptDateFrom, receiptDateTo, studentIndexNo, studentName, receiptStatus, mode, schoolID) {
    const data = {
      receiptName: receiptName,
      invoiceName: invoiceName,
      receiptDateFrom: receiptDateFrom,
      receiptDateTo: receiptDateTo,
      studentIndexNo: studentIndexNo,
      studentName: studentName,
      receiptStatus: receiptStatus,
      schoolID: schoolID,
      mode: mode,
    }
    return await this.callWebService('/controller/Billing.asmx/getReceiptList', data, 'POST')
  }

  async getPayee(studentID_Index) {
    const data = {
      studentID_Index: studentID_Index,
    }
    return await this.callWebService('/controller/Students.asmx/getPayee', data, 'POST')
  }

  async getReceiptDetails(receiptID) {
    const data = {
      receiptID: receiptID,
    }
    return await this.callWebService('/controller/Billing.asmx/getReceiptDetails', data, 'POST')
  }

  async getUnbilledBatchPaymentList(schoolID, semesterID, courseID, classID, fromDate, toDate) {
    const data = {
      schoolID: schoolID,
      semesterID: semesterID,
      courseID: courseID,
      classID: classID,
      fromDate: fromDate,
      toDate: toDate,
    }
    return await this.callWebService('/controller/Billing.asmx/getUnbilledBatchPaymentList', data, 'POST')
  }

  async cancelReceipt(receiptID, remarks) {
    const data = {
      receiptID: receiptID,
      remarks: remarks,
    }
    return await this.callWebService('/controller/Billing.asmx/cancelReceipt', data, 'POST')
  }

  async generateBatchInvoice(obj, inputPaymentDueDate, action, breakdownFlag) {
    const data = {
      obj: obj,
      inputPaymentDueDate: inputPaymentDueDate,
      action: action,
      breakdownFlag: breakdownFlag,
    }
    return await this.callWebService('/controller/Billing.asmx/generateBatchInvoice', data, 'POST')
  }

  async importECADetailsByCSVExcel(files, ecaID) {
    const data = new FormData()
    data.append('token', Cookies.get('authToken'))
    data.append('UserSchool_Session', Cookies.get('schoolSession'))
    data.append('UserID_Session', Cookies.get('userIDSession'))
    data.append('UserUniversity_Session', Cookies.get('userUniversitySession'))

    if (files && files.length > 1) {
      for (let key in files) {
        if (files.hasOwnProperty(key)) {
          if (key > 0) {
            data.append(`upload_${key}`, files[key])
          } else {
            data.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      data.append('upload', files[0])
    }

    data.append('ecaID', ecaID)

    const request = {
      url: `${API_HOST}/controller/Attendance.asmx/importECADetailsByCSVExcel`,
      cache: false,
      type: 'POST',
      data: data,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async getValueFromGeneralSearch(searchValueInput) {
    const data = {
      searchValueInput: searchValueInput,
    }
    return await this.callWebService('/controller/General.asmx/getValueFromGeneralSearch', data, 'POST')
  }

  async generatePortfolioPDF(portfolioID) {
    const data = {
      portfolioID: portfolioID,
    }
    return await this.callWebService('/controller/Portfolio.asmx/generatePortfolioPDF', data, 'POST')
  }

  async getTransferPendingScheduleList() {
    const data = {}
    return await this.callWebService('/controller/Operations.asmx/getTransferPendingScheduleList', data, 'POST')
  }

  async updateTransferPendingScheduleList(studentSchoolID, status) {
    const data = {
      studentSchoolID: studentSchoolID,
      status: status,
    }
    return await this.callWebService('/controller/Operations.asmx/updateTransferPendingScheduleList', data, 'POST')
  }

  async getWithdrawGraduatePendingScheduleList(changeType) {
    const data = {
      changeType: changeType,
    }
    return await this.callWebService('/controller/Operations.asmx/getWithdrawGraduatePendingScheduleList', data, 'POST')
  }

  async updateWithdrawGraduatePendingScheduleList(studentGraduationDatesID, status) {
    const data = {
      studentGraduationDatesID: studentGraduationDatesID,
      status: status,
    }
    return await this.callWebService('/controller/Operations.asmx/updateWithdrawGraduatePendingScheduleList', data, 'POST')
  }

  async getReminderEmail(noOfReminder, invoiceNo, studentCourseID, studentID) {
    const data = {
      noOfReminder: noOfReminder,
      invoiceNo: invoiceNo,
      studentCourseID: studentCourseID,
      studentID: studentID,
    }
    return await this.callWebService('/controller/Billing.asmx/getReminderEmail', data, 'POST')
  }

  async sendReminderEmail(emailTo, emailSubject, emailMessage, invoiceNo) {
    const data = {
      emailTo: emailTo,
      emailSubject: emailSubject,
      emailMessage: emailMessage,
      invoiceNo: invoiceNo,
    }
    return await this.callWebService('/controller/Billing.asmx/sendReminderEmail', data, 'POST')
  }

  async getCourseBySemesterID(schoolID, semesterID) {
    const data = {
      schoolID: schoolID,
      semesterID: semesterID,
    }
    return await this.callWebService('/controller/Course.asmx/getCourseBySemesterID', data, 'POST')
  }

  async getSchoolCourseBySemesterId(schoolID, semesterID) {
    const data = {
      schoolID: schoolID,
      semesterID: semesterID,
    }
    return await this.callWebService('/controller/Course.asmx/getSchoolCourseBySemesterId', data, 'POST')
  }

  async getClassByMonthYear(month, year, filterByStaffInCharge) {
    const data = {
      month: month,
      year: year,
      filterByStaffInCharge: filterByStaffInCharge,
    }
    return await this.callWebService('/controller/Class.asmx/getClassByMonthYear', data, 'POST')
  }

  async getClassAttendanceReportByMonthYear(month, year, classID, reportType) {
    const data = {
      month: month,
      year: year,
      classID: classID,
      reportType: reportType,
    }
    return await this.callWebService('/controller/Attendance.asmx/getClassAttendanceReportByMonthYear', data, 'POST')
  }

  async getInvoiceCNList(invoiceDateFrom, invoiceDateTo, invoiceDueDateFrom, invoiceDueDateTo, studentIndexNo, invoiceNo, studentName, type, studentID) {
    const data = {
      invoiceDateFrom: invoiceDateFrom,
      invoiceDateTo: invoiceDateTo,
      invoiceDueDateFrom: invoiceDueDateFrom,
      invoiceDueDateTo: invoiceDueDateTo,
      studentIndexNo: studentIndexNo,
      invoiceNo: invoiceNo,
      studentName: studentName,
      type: type,
      studentID: studentID,
    }
    return await this.callWebService('/controller/Billing.asmx/getInvoiceCNList', data, 'POST')
  }

  async getAgentCommissionList(agentName, studentName, type) {
    const data = {
      agentName: agentName,
      studentName: studentName,
      type: type,
    }
    return await this.callWebService('/controller/AgentTracker.asmx/getAgentCommissionList', data, 'POST')
  }

  async getddlAcadYearList(StudentId) {
    const data = {
      StudentId: StudentId,
    }
    return await this.callWebService('/controller/AgentTracker.asmx/getAcademicYearByStudent', data, 'POST')
  }

  async getddlSemesterTermList(semesterID) {
    const data = {
      semesterID: semesterID,
    }
    return await this.callWebService('/controller/AgentTracker.asmx/getSemesterTerm', data, 'POST')
  }

  async getAgentDetailList(agentname, studentName, type) {
    const data = {
      agentname: agentname,
      studentName: studentName,
      type: type,
    }
    return await this.callWebService('/controller/AgentTracker.asmx/getAgentDetailList', data, 'POST')
  }

  async getAgentList(studentIndexNo, studentName, type) {
    const data = {
      AgentName: studentName,
      AgentShortName: studentIndexNo,
      type: type,
    }
    return await this.callWebService('/controller/AgentTracker.asmx/getAgentList', data, 'POST')
  }

  async getJapanschoolIDs() {
    const data = {
      AgentName: '',
      AgentShortName: '',
      type: '',
    }
    return await this.callWebService('/controller/AgentTracker.asmx/getJapanschoolIDs', data, 'POST')
  }

  async getAgentOnboardDate(agentname, studentid, obdate, type) {
    const data = {
      agentname: agentname,
      studentid: studentid,
      obdate: obdate,
      type: type,
    }
    return await this.callWebService('/controller/AgentTracker.asmx/getAgentOnboardDate', data, 'POST')
  }

  async getItemTotalReceipt(receiptNameListObj) {
    const data = {
      receiptNameListObj: receiptNameListObj,
    }
    return await this.callWebService('/controller/Billing.asmx/getItemTotalReceipt', data, 'POST')
  }

  async advanceAttendanceMarking(jsonString) {
    const data = {
      jsonString: jsonString,
    }
    return await this.callWebService('/controller/Attendance.asmx/advanceAttendanceMarking', data, 'POST')
  }

  async generateRefund(obj, action, refundGstRate) {
    const data = {
      obj: obj,
      action: action,
      GstPercentage: refundGstRate,
    }
    return await this.callWebService('/controller/Billing.asmx/generateRefund', data, 'POST')
  }

  async getadvanceAttendanceMarkingList() {
    const data = {}
    return await this.callWebService('/controller/Attendance.asmx/getAdvanceAttendanceMarkingList', data, 'POST')
  }

  async updateAdvanceAttendanceMarking(mode, attendanceID) {
    const data = {
      mode: mode,
      attendanceID: attendanceID,
    }
    return await this.callWebService('/controller/Attendance.asmx/updateAdvanceAttendanceMarking', data, 'POST')
  }

  async getClassStudentByClassIDIncludeInactive(classValue) {
    const data = {
      classValue: classValue,
    }
    return await this.callWebService('/controller/Class.asmx/getClassStudentByClassIDIncludeInactive', data, 'POST')
  }

  async getClassStudentByClassID(classValue) {
    const data = {
      classValue: classValue,
    }
    return await this.callWebService('/controller/Class.asmx/getClassStudentByClassID', data, 'POST')
  }

  async getAgencyListSummary(academicYear) {
    const data = {
      academicYear: academicYear,
    }
    return await this.callWebService('/controller/AgentTracker.asmx/getAgencyListSummary', data, 'POST')
  }

  async getAgencyStudentList(agentname, academicYear) {
    const data = {
      academicYear: academicYear,
      agentname: agentname,
    }
    return await this.callWebService('/controller/AgentTracker.asmx/getAgencyStudentList', data, 'POST')
  }

  async checkDeferActionValid(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Students.asmx/checkDeferActionValid', data, 'POST')
  }

  async setDeferDate(studentID, deferDate) {
    const data = {
      studentID: studentID,
      deferDate: deferDate,
    }
    return await this.callWebService('/controller/Students.asmx/setDeferDate', data, 'POST')
  }

  async sendEmailInvoice(obj) {
    const data = {
      obj: obj,
    }
    return await this.callWebService('/controller/Billing.asmx/sendEmailInvoice', data, 'POST')
  }

  async sendEmailRebate(obj) {
    const data = {
      obj: obj,
    }
    return await this.callWebService('/controller/Billing.asmx/sendEmailRebate', data, 'POST')
  }

  async checkCourseOrderByLevelIDStudentID(levelID, studentID) {
    const data = {
      levelID: levelID,
      studentID: studentID,
    }
    return await this.callWebService('/controller/Course.asmx/checkCourseOrderByLevelIDStudentID', data, 'POST')
  }

  async sendBreakdownEmail(obj) {
    const data = {
      obj: obj,
    }
    return await this.callWebService('/controller/Billing.asmx/sendBreakdownEmail', data, 'POST')
  }

  async saveNewAgent(agentname, agentshortname, agentid, agentstatus) {
    const data = {
      agentname: agentname,
      agentshortname: agentshortname,
      agentid: agentid,
      agentstatus: agentstatus,
      UserID_Session: Cookies.get('userIDSession'),
    }
    return await this.callWebService('/controller/AgentTracker.asmx/saveNewAgent', data, 'POST')
  }

  async saveAgentStudent(editId, SchoolFee, Remarks, Status, AgentId, SchoolId, CourseId, StudentId) {
    const data = {
      editId: editId,
      SchoolFee: SchoolFee,
      Remarks: Remarks,
      Status: Status,
      AgentId: AgentId,
      SchoolId: SchoolId,
      CourseId: CourseId,
      StudentId: StudentId,
      UserID_Session: Cookies.get('userIDSession'),
    }
    return await this.callWebService('/controller/AgentTracker.asmx/saveAgentStudent', data, 'POST')
  }

  async saveAgentCommission(editId, receiptAmt, Commission, PaidAgentDate, InvoiceRefNo, Remarks, Status, agentid, studentid, receiptno, SemDetID) {
    const data = {
      editId: editId,
      receiptAmt: receiptAmt,
      Commission: Commission,
      PaidAgentDate: PaidAgentDate,
      InvoiceRefNo: InvoiceRefNo,
      Remarks: Remarks,
      Status: Status,
      agentid: agentid,
      studentid: studentid,
      receiptno: receiptno,
      SemDetID: SemDetID,
      UserID_Session: Cookies.get('userIDSession'),
    }
    return await this.callWebService('/controller/AgentTracker.asmx/saveAgentCommission', data, 'POST')
  }

  async generateClassStudentForPrinting(obj) {
    const data = {
      obj: obj,
    }
    return await this.callWebService('/controller/Class.asmx/generateClassStudentForPrinting', data, 'POST')
  }

  async generateClassStudentQRForPrinting(obj) {
    const data = {
      obj: obj,
    }
    return await this.callWebService('/controller/Class.asmx/generateClassStudentForPrintingQR', data, 'POST')
  }

  async getAllCoursesLevel() {
    const data = {}
    return await this.callWebService('/controller/Course.asmx/getAllCoursesLevel', data, 'POST')
  }

  async getPlannerMaster(level, type, mode, lang, courseType) {
    const data = {
      level: level,
      type: type,
      mode: mode,
      lang: lang,
      courseType: courseType,
    }
    return await this.callWebService('/controller/Portfolio.asmx/getPlannerMaster', data, 'POST')
  }

  async getPlannerMaster2(level) {
    const data = {
      levels: level,
    }
    return await this.callWebService('/controller/Api.asmx/GetPlannerMaster', data, 'POST')
  }

  async savePlannerMaster(newPlannerMasterObjJson) {
    const data = {
      newPlannerMasterObjJson: newPlannerMasterObjJson,
    }
    return await this.callWebService('/controller/Portfolio.asmx/savePlannerMaster', data, 'POST')
  }

  async updatePlannerMaster(plannerMasterID, mode) {
    const data = {
      plannerMasterID: plannerMasterID,
      mode: mode,
    }
    return await this.callWebService('/controller/Portfolio.asmx/updatePlannerMaster', data, 'POST')
  }

  async getPlannerAssignedToSchool(schID, semID) {
    const data = {
      schID: schID,
      semID: semID,
    }
    return await this.callWebService('/controller/Portfolio.asmx/getPlannerAssignedToSchool', data, 'POST')
  }

  async getPlannerAssignedDetialsToSchool(schID, semID, crsID) {
    const data = {
      schID: schID,
      semID: semID,
      crsID: crsID,
    }
    return await this.callWebService('/controller/Portfolio.asmx/getPlannerAssignedDetialsToSchool', data, 'POST')
  }

  async updatePlannerAssignedDetialsToSchool(plannerSchoolAssginDetailsID, mode) {
    const data = {
      plannerSchoolAssginDetailsID: plannerSchoolAssginDetailsID,
      mode: mode,
    }
    return await this.callWebService('/controller/Portfolio.asmx/updatePlannerAssignedDetialsToSchool', data, 'POST')
  }

  async getPlannerUnAssignToSchool(crsID, semID, schID, levelType) {
    const data = {
      schID: schID,
      semID: semID,
      crsID: crsID,
      levelType: levelType,
    }
    return await this.callWebService('/controller/Portfolio.asmx/getPlannerUnAssignToSchool', data, 'POST')
  }

  async savePlannerAssignedToSchool(newPlannerAssignedToSchoolObjJson) {
    const data = {
      newPlannerAssignedToSchoolObjJson: newPlannerAssignedToSchoolObjJson,
    }
    return await this.callWebService('/controller/Portfolio.asmx/savePlannerAssignedToSchool', data, 'POST')
  }

  async savePlannerAssignedToClass(newPlannerAssignedToClassObjJson) {
    const data = {
      newPlannerAssignedToClassObjJson: newPlannerAssignedToClassObjJson,
    }
    return await this.callWebService('/controller/Planner.asmx/savePlannerAssignedToClass', data, 'POST')
  }

  async SavePlannerAssignedToClass2(classId, checkList) {
    const data = {
      data: JSON.stringify(checkList),
      classID: classId,
    }
    return await this.callWebService('/controller/Api.asmx/SavePlannerAssignedToClass', data, 'POST')
  }

  async SavePlannerAssignedToStudent(studentID, checkList) {
    const data = {
      data: JSON.stringify(checkList),
      studentID: studentID,
    }
    return await this.callWebService('/controller/Api.asmx/SavePlannerAssignedToStudent', data, 'POST')
  }

  async SavePlannerAssignedToClass2(classId, checkList) {
    const data = {
      data: JSON.stringify(checkList),
      classID: classId,
    }
    return await this.callWebService('/controller/Api.asmx/SavePlannerAssignedToClass', data, 'POST')
  }

  async SavePlannerAssignedToStudent(studentID, checkList) {
    const data = {
      data: JSON.stringify(checkList),
      studentID: studentID,
    }
    return await this.callWebService('/controller/Api.asmx/SavePlannerAssignedToStudent', data, 'POST')
  }

  async savePlannerAssignedToCourse(newPlannerAssignedToCourseObjJson) {
    const data = {
      newPlannerAssignedToCourseObjJson: newPlannerAssignedToCourseObjJson,
    }
    return await this.callWebService('/controller/Planner.asmx/savePlannerAssignedToCourse', data, 'POST')
  }

  async savePlannerAssignedToStudentK2(newPlannerAssignedToStudentObjJson) {
    const data = {
      newPlannerAssignedToStudentObjJson: newPlannerAssignedToStudentObjJson,
    }
    return await this.callWebService('/controller/Planner.asmx/savePlannerAssignedToStudentK2', data, 'POST')
  }

  async getPlannerAssignedToClass(crsID, classID, semdID) {
    const data = {
      crsID: crsID,
      classID: classID,
      semdID: semdID,
    }
    return await this.callWebService('/controller/Planner.asmx/getPlannerAssignedToClass', data, 'POST')
  }

  async getPlannerAssignedToClass2(classID) {
    const data = {
      classID: classID,
    }
    return await this.callWebService('/controller/Api.asmx/GetPlannerAssignedToClass', data, 'POST')
  }

  async GetPlannerAssignedToStudent(studID) {
    const data = {
      studID: studID,
    }
    return await this.callWebService('/controller/Api.asmx/GetPlannerAssignedToStudent', data, 'POST')
  }

  async getPlannerAssignedToClassReworked(crsID, classID, semID, Term1SemdID, Term2SemdID, Term3SemdID, Term4SemdID) {
    const data = {
      crsID: crsID,
      classID: classID,
      semID: semID,
      Term1SemdID: Term1SemdID,
      Term2SemdID: Term2SemdID,
      Term3SemdID: Term3SemdID,
      Term4SemdID: Term4SemdID,
    }
    return await this.callWebService('/controller/Planner.asmx/getPlannerAssignedToClassReworked', data, 'POST')
  }

  async getPlannerAssignedToLevel(crsID, semdID) {
    const data = {
      crsID: crsID,
      semdID: semdID,
    }
    return await this.callWebService('/controller/Planner.asmx/getPlannerAssignedToLevel', data, 'POST')
  }

  async getPlannerAssignedToStudent(crsID, classID, termID, studentID) {
    const data = {
      crsID: crsID,
      classID: classID,
      semdID: termID,
      studentID: studentID,
    }
    return await this.callWebService('/controller/Planner.asmx/getPlannerAssignedToStudent', data, 'POST')
  }

  async getStudentsByClass(crsID, classID, semID) {
    const data = {
      crsID: crsID,
      semID: semID,
      classID: classID,
    }
    return await this.callWebService('/controller/Portfolio.asmx/getStudentsByClass', data, 'POST')
  }

  async GetAttendanceWithStudentType(studentType, courseID, ClassID, Index_No, fromDate, toDate) {
    const data = {
      studentType: studentType,
      courseID: courseID,
      ClassID: ClassID,
      Index_No: Index_No,
      fromDate: fromDate,
      toDate: toDate,
    }
    return await this.callWebService('/controller/Attendance.asmx/GetAttendanceWithStudentType', data, 'POST')
  }

  async GetAttendanceWithStudentTypeSummary(studentType, courseID, ClassID, Index_No, fromDate, toDate) {
    const data = {
      studentType: studentType,
      courseID: courseID,
      ClassID: ClassID,
      Index_No: Index_No,
      fromDate: fromDate,
      toDate: toDate,
    }
    return await this.callWebService('/controller/Attendance.asmx/GetAttendanceWithStudentTypeSummary', data, 'POST')
  }

  async getPlannerAssignedStudentSummaryByClassSemester(classValue) {
    const data = {
      classValue: classValue,
    }
    return await this.callWebService('/controller/Portfolio.asmx/getPlannerAssignedStudentSummaryByClassSemester', data, 'POST')
  }

  async getPlannerAssignedStudentDetails(mode, studentID, semID, crsID, semdID, plannerApproverID) {
    const data = {
      studentID: studentID,
      semID: semID,
      crsID: crsID,
      semdID: semdID,
      mode: mode,
      plannerApproverID: plannerApproverID,
    }
    return await this.callWebService('/controller/Portfolio.asmx/getPlannerAssignedStudentDetails', data, 'POST')
  }

  async savePlannerAssignStudent(newPlannerStudentObjJson, approverComment) {
    const data = {
      newPlannerStudentObjJson: newPlannerStudentObjJson,
      approverComment: approverComment,
    }
    return await this.callWebService('/controller/Portfolio.asmx/savePlannerAssignStudent', data, 'POST')
  }

  async deletePlannerAssignStudentPendingApprover(approverID) {
    const data = {
      approverID: approverID,
    }
    return await this.callWebService('/controller/Portfolio.asmx/deletePlannerAssignStudentPendingApprover', data, 'POST')
  }

  async getPlannerAssignedStudentsGroupByClassID(classID, studentIDJsonString) {
    const data = {
      classID: classID,
      studentIDJsonString: studentIDJsonString,
    }
    return await this.callWebService('/controller/Portfolio.asmx/getPlannerAssignedStudentsGroupByClassID', data, 'POST')
  }

  async getPlannerAssignedStudentsGroupByClassIDK2(classIDList, studentIDList) {
    const data = {
      classIDList: JSON.stringify(classIDList),
      studentIDList: JSON.stringify(studentIDList),
    }
    return await this.callWebService('/controller/Planner.asmx/getPlannerAssignedStudentsGroupByClassIDK2', data, 'POST')
  }

  async getNewPlannerAssigned(classIDList, studentIDList, levelIDList) {
    const data = {
      courses: JSON.stringify(levelIDList),
      classes: JSON.stringify(classIDList),
      students: JSON.stringify(studentIDList),
    }

    return await this.callWebService('/controller/Api.asmx/GetPlannerAssigned', data, 'POST')
  }

  async getStudentPlannerProgressByClassIDRange(classID, studentID, semdID) {
    const data = {
      classID: classID,
      studentID: studentID,
      semdID: semdID,
    }
    return await this.callWebService('/controller/Portfolio.asmx/getStudentPlannerProgressByClassIDRange', data, 'POST')
  }

  async getPendingStudentMovementStatusAction(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Students.asmx/getPendingStudentMovementStatusAction', data, 'POST')
  }

  async getTransactionListing(inputFromDate, inputToDate, dateRange, type) {
    const data = {
      dateFrom: inputFromDate,
      dateTo: inputToDate,
      type: type,
      dateRange: dateRange,
    }
    return await this.callWebService('/controller/Billing.asmx/getTransactionListing', data, 'POST')
  }

  async getStudentListReport(semID, password = null) {
    const data = { semID, password, email: Cookies.get('userEmailSession') }
    return await this.callWebService('/controller/Students.asmx/getStudentListReport', data, 'POST')
  }

  async sendEmailReceipt(obj) {
    const data = {
      obj: obj,
    }
    return await this.callWebService('/controller/Billing.asmx/sendEmailReceipt', data, 'POST')
  }

  async getSalesLedger(type, dateRange, inputFromDate, inputToDate) {
    const data = {
      type: type,
      dateRange: dateRange,
      dateFrom: inputFromDate,
      dateTo: inputToDate,
    }
    return await this.callWebService('/controller/Billing.asmx/getSalesLedger', data, 'POST')
  }

  async studentEmailAction(mode, studentIndexNo) {
    const data = {
      mode: mode,
      studentIndexNo: studentIndexNo,
    }
    return await this.callWebService('/controller/Students.asmx/studentEmailAction', data, 'POST')
  }

  async studentEmailActionManualPassword(mode, studentIndexNo, password) {
    const data = {
      mode: mode,
      studentIndexNo: studentIndexNo,
      password: password,
    }
    return await this.callWebService('/controller/Students.asmx/studentEmailAction', data, 'POST')
  }

  async studentEmailActionByBatch(mode, studentIndexNoBatch) {
    const data = {
      mode: mode,
      studentIndexNoBatch: studentIndexNoBatch,
    }
    return await this.callWebService('/controller/Students.asmx/studentEmailAction', data, 'POST')
  }

  async getPostPortfolioDetailsPortfolioByPassToken(portfolioDetailsPostID, type, byPassToken) {
    const data = {
      portfolioDetailsPostID: portfolioDetailsPostID,
      type: type,
      byPassToken: byPassToken,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostPortfolioDetailsPortfolio', data, 'POST')
  }

  async getPostPortfolioDetailsThemesByPassToken(portfolioDetailsPostID, byPassToken) {
    const data = {
      portfolioDetailsPostID: portfolioDetailsPostID,
      byPassToken: byPassToken,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostPortfolioDetailsThemes', data, 'POST')
  }

  async getZipFiles(obj, type) {
    const data = {
      obj: obj,
      type: type,
    }
    return await this.callWebService('/controller/Billing.asmx/getZipFiles', data, 'POST')
  }

  async getHubSpotDetails(dealID) {
    const data = {
      dealId: dealID,
    }

    const request = {
      url: `${API_HOST2}/hubspot/getHubspotDetail`,
      data: JSON.stringify(data),
      cache: false,
      type: 'POST',
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }

    return response
  }

  async getStudentHubSpotDetials(studentID, dealID) {
    const data = {
      studentID: studentID,
      dealID: dealID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentHubSpotDetials', data, 'POST')
  }

  async getStudentHubSpotAttachment(HsdItemID) {
    const data = {
      HsdItemID: HsdItemID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentHubSpotAttachment', data, 'POST')
  }

  async saveBatchItem(studentCourseObj, itemObj) {
    const data = {
      studentCourseObj: studentCourseObj,
      itemObj: itemObj,
    }
    return await this.callWebService('/controller/billing.asmx/saveBatchItem', data, 'POST')
  }

  async getActiveStudentsBySemSchool(semID, levelID, classID, studentCourseStatus, mealPreference, additionalLanguage, subsidy) {
    const data = {
      semID: semID,
      levelID: levelID,
      classID: classID,
      studentCourseStatus: studentCourseStatus,
      mealPreference: mealPreference,
      additionalLanguage: additionalLanguage,
      subsidy: subsidy,
    }
    return await this.callWebService('/controller/students.asmx/getActiveStudentsBySemSchool', data, 'POST')
  }

  async getBatchPaymentPlanMasterList(schoolID, courseID, classID) {
    const data = {
      schoolID: schoolID,
      courseID: courseID,
      classID: classID,
    }
    return await this.callWebService('/controller/billing.asmx/getBatchPaymentPlanMasterList', data, 'POST')
  }

  async saveBatchPaymentPlan(studentCourseObj, paymentPlanObj) {
    const data = {
      studentCourseObj: studentCourseObj,
      paymentPlanObj: paymentPlanObj,
    }
    return await this.callWebService('/controller/billing.asmx/saveBatchPaymentPlan', data, 'POST')
  }

  async getBatchPaymentStartDate(semesterID, courseID, classID, studentCourseStatus) {
    const data = {
      semesterID: semesterID,
      courseID: courseID,
      classID: classID,
      studentCourseStatus: studentCourseStatus,
    }
    return await this.callWebService('/controller/billing.asmx/getBatchPaymentStartDate', data, 'POST')
  }

  async getStudentAuthorizedPickup(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentAuthorizedPickup', data, 'POST')
  }

  async getPickupAcknowledgementDetail(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Students.asmx/getPickupAcknowledgement', data, 'POST')
  }

  async savePickupAcknowledgement(base64String, studentID, AuthPickUpID, pickAuthStatus, PaType) {
    const data = {
      base64String: base64String,
      studentID: studentID,
      AuthPickUpID: AuthPickUpID,
      pickAuthStatus: pickAuthStatus,
      PaType: PaType,
    }
    return await this.callWebService('/controller/Students.asmx/savePickupAcknowledgement', data, 'POST')
  }

  async getGlobalUniversityCode() {
    const data = {}
    return await this.callWebService('/controller/General.asmx/getGlobalUniversityCode', data, 'POST')
  }

  async getSemesterTermDetailsBySemID(semesterID, semdID, SMT_Status) {
    const data = {
      semesterID: semesterID,
      SMT_Status: SMT_Status,
      semd_ID: semdID,
    }
    return await this.callWebService('/controller/Course.asmx/getSemesterTermDetails', data, 'POST')
  }

  async getSemesterTermDetailsBySemDetailID(semesterID, semd_ID) {
    const data = {
      semd_ID: semd_ID,
    }
    return await this.callWebService('/controller/Course.asmx/getSemesterTermDetails', data, 'POST')
  }

  async getNotificationsByRowNumber(natID, numberOfRows, passNumberOfDays) {
    const data = {
      natID: natID,
      numberOfRows: numberOfRows,
      passNumberOfDays: passNumberOfDays,
    }
    return await this.callWebService('/controller/Posting.asmx/getNotificationsByRowNumber', data, 'POST')
  }

  async updateNotificationsStatus(natID, action) {
    const data = {
      natID: natID,
      action: action,
    }
    return await this.callWebService('/controller/Posting.asmx/updateNotifications', data, 'POST')
  }

  async getPayNowItems(InvoiceName, studentID, isEncrypted, ID) {
    const data = {
      InvoiceName: InvoiceName,
      studentID: studentID,
      isEncrypted: isEncrypted,
      ID: ID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPayNowItems', data, 'POST')
  }

  async getQRCode(invoiceName, studentID, totalAmount, isEncrypted, ID) {
    const data = {
      invoiceName: invoiceName,
      studentID: studentID,
      totalAmount: totalAmount,
      isEncrypted: isEncrypted,
      ID: ID,
    }
    return await this.callWebService('/controller/Billing.asmx/getQRCode', data, 'POST')
  }

  async getQRCodeNew(totalAmount, invoiceName, schoolUEN, schoolName) {
    const school = schoolName.replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, ' ')
    const paynow = `/paynow?amount=${totalAmount}&reference=${invoiceName.trim()}&uen=${schoolUEN.trim()}&name=${school.trim()}`
    return await this.callAPI(paynow, 'GET', null, null, false, 'https://payment.etonhouse.com')
  }

  async getPaymentGatewayStudentDetail(invoiceName, studentID, totalAmount, isEncrypted, type, ID) {
    const data = {
      invoiceName: invoiceName,
      studentID: studentID,
      totalAmount: totalAmount,
      isEncrypted: isEncrypted,
      type: type,
      ID: ID,
    }
    return await this.callWebService('/controller/Billing.asmx/getStudentDtlPaymentGateway', data, 'POST')
  }

  async getStudentDtlPaymentGateway(invoiceName, studentID, totalAmount, isEncrypted, type) {
    const data = {
      invoiceName: invoiceName,
      studentID: studentID,
      totalAmount: totalAmount,
      isEncrypted: isEncrypted,
      type: type,
    }
    return await this.callWebService('/controller/Billing.asmx/getStudentDtlPaymentGateway', data, 'POST')
  }

  async getPaymentStatus(invoiceName, studentID, totalAmount, isEncrypted, ID) {
    const data = {
      invoiceName: invoiceName,
      studentID: studentID,
      totalAmount: totalAmount,
      isEncrypted: isEncrypted,
      ID: ID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentStatus', data, 'POST')
  }

  async reprintInvoice(InvRecID, studentID) {
    const data = {
      InvRecID: InvRecID,
      studentID: studentID,
    }
    return await this.callWebService('/controller/Billing.asmx/reprintInvoice', data, 'POST')
  }

  async reprintReceipt(InvRecID, studentID) {
    const data = {
      InvRecID: InvRecID,
      studentID: studentID,
    }
    return await this.callWebService('/controller/Billing.asmx/reprintReceipt', data, 'POST')
  }

  async getReprintHistoryList(InvRecID, type) {
    const data = {
      InvRecID: InvRecID,
      type: type,
    }
    return await this.callWebService('/controller/Billing.asmx/getReprintHistoryList', data, 'POST')
  }

  async getReprintDocumentHistory(InvRecID, auditID, type) {
    const data = {
      InvRecID: InvRecID,
      auditID: auditID,
      type: type,
    }
    return await this.callWebService('/controller/Billing.asmx/getReprintDocumentHistory', data, 'POST')
  }

  async InviteParentRegister(email, type, parentID) {
    const data = {
      email: email,
      type: type,
      parentID: parentID,
    }

    return await this.callWebService('/controller/Api.asmx/CreateParentAccount', data, 'POST')
  }

  async GetParentRegisterDetails(inputString) {
    const data = {
      inputString: inputString,
    }

    return await this.callWebService('/controller/Register.asmx/GetParentRegisterDetails', data, 'POST')
  }

  async parentRegistrationByLink(email, password, type, parentID, notification) {
    const data = {
      email: email,
      password: password,
      type: type,
      parentID: parentID,
      notification: notification,
    }

    return await this.callWebService('/controller/Register.asmx/parentRegistrationByLink', data, 'POST')
  }

  async updateUserConfigurationLanguege(value) {
    const data = {
      value: value,
    }

    return await this.callWebService('/controller/User.asmx/updateUserConfigurationLanguege', data, 'POST')
  }

  async getClassBySemesterLevel(crsID, semID) {
    const data = {
      crsID: crsID,
      semID: semID,
    }

    return await this.callWebService('/controller/Class.asmx/getClassBySemesterLevel', data, 'POST')
  }

  async getClassesInchargeSpecialistStaff(levelID, semesterID, className, classID) {
    const data = {
      levelID: levelID,
      semesterID: semesterID,
      className: className,
      // Scopes the fetch to this specific class/batch row (see updateClass).
      classID: classID,
    }

    return await this.callWebService('/controller/Class.asmx/getClassesInchargeSpecialistStaff', data, 'POST')
  }

  async getNavigationMenuMaster() {
    const data = {}

    return await this.callWebService('/controller/UserMagt.asmx/getNavigationMenuMaster', data, 'POST')
  }

  async saveNavigationMenu(newMenuName) {
    const data = {
      newMenuName: newMenuName,
    }

    return await this.callWebService('/controller/UserMagt.asmx/saveNavigationMenu', data, 'POST')
  }

  async updateNavigationMenu(menuID, mode) {
    const data = {
      menuID: menuID,
      mode: mode,
    }

    return await this.callWebService('/controller/UserMagt.asmx/updateNavigationMenu', data, 'POST')
  }

  async getNavigationSubMenuByMenuID(menuID) {
    const data = {
      menuID: menuID,
    }

    return await this.callWebService('/controller/UserMagt.asmx/getNavigationSubMenuByMenuID', data, 'POST')
  }

  async saveNavigationSubMenu(newSubMenuName, newSubMenuLink, menuID) {
    const data = {
      newSubMenuName: newSubMenuName,
      newSubMenuLink: newSubMenuLink,
      menuID: menuID,
    }

    return await this.callWebService('/controller/UserMagt.asmx/saveNavigationSubMenu', data, 'POST')
  }

  async updateNavigationSubMenu(subMenuID, mode) {
    const data = {
      subMenuID: subMenuID,
      mode: mode,
    }

    return await this.callWebService('/controller/UserMagt.asmx/updateNavigationSubMenu', data, 'POST')
  }

  async getNavigationSubMenuWithoutMenu() {
    const data = {}

    return await this.callWebService('/controller/UserMagt.asmx/getNavigationSubMenuWithoutMenu', data, 'POST')
  }

  async getUserGroup() {
    const data = {}

    return await this.callWebService('/controller/UserMagt.asmx/getUserGroup', data, 'POST')
  }

  async getNavigationGroupAccessByGroupID(groupID) {
    const data = {
      groupID: groupID,
    }

    return await this.callWebService('/controller/UserMagt.asmx/getNavigationGroupAccessByGroupID', data, 'POST')
  }

  async getUnassignedSubMenuToGroupAccessByGroupID(groupID) {
    const data = {
      groupID: groupID,
    }

    return await this.callWebService('/controller/UserMagt.asmx/getUnassignedSubMenuToGroupAccessByGroupID', data, 'POST')
  }

  async saveNavigationGroupAccess(subMenuID, groupID) {
    const data = {
      subMenuID: subMenuID,
      groupID: groupID,
    }

    return await this.callWebService('/controller/UserMagt.asmx/saveNavigationGroupAccess', data, 'POST')
  }

  async updateNavigationGroupAccess(groupAccessID, mode) {
    const data = {
      groupAccessID: groupAccessID,
      mode: mode,
    }

    return await this.callWebService('/controller/UserMagt.asmx/updateNavigationGroupAccess', data, 'POST')
  }

  async savePTCEvent(files, obj, participantObj, timeslotObj) {
    const formData = new FormData()
    formData.append('obj', obj)
    formData.append('ParticipantObj', participantObj)
    formData.append('TimeslotObj', timeslotObj)
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('UserType_Session', Cookies.get('userTypeSession'))
    formData.append('UserUniversitySession', Cookies.get('userUniversitySession'))
    formData.append('UserEmailSession', Cookies.get('userEmailSession'))
    formData.append('USRidSession', Cookies.get('usRidSession'))
    formData.append('UserNameSession', Cookies.get('userNameSession'))
    console.log(files, 'files')
    if (files && files.length > 1) {
      for (let key in files) {
        if (files.hasOwnProperty(key)) {
          if (key > 0) {
            formData.append(`upload_${key}`, files[key])
          } else {
            formData.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      formData.append('upload', files[0])
    }
    const request = {
      url: `${API_HOST}/controller/Event.asmx/saveEvent`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }
    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async getPtcTimeslots(eventID) {
    const data = {
      eventID: eventID,
    }

    return await this.callWebService('/controller/Event.asmx/getEventTimeslots', data, 'POST')
  }

  async updatePTCEvent(files, obj, participantObj, timeslotObj, timeslotValid) {
    const formData = new FormData()
    formData.append('obj', obj)
    formData.append('ParticipantObj', participantObj)
    formData.append('TimeslotObj', timeslotObj)
    formData.append('timeslotValid', timeslotValid)
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('UserType_Session', Cookies.get('userTypeSession'))
    formData.append('UserUniversitySession', Cookies.get('userUniversitySession'))
    formData.append('UserEmailSession', Cookies.get('userEmailSession'))
    formData.append('USRidSession', Cookies.get('usRidSession'))
    formData.append('UserNameSession', Cookies.get('userNameSession'))
    if (files && files.length > 1) {
      for (let key in files) {
        if (files.hasOwnProperty(key)) {
          if (key > 0) {
            formData.append(`upload_${key}`, files[key])
          } else {
            formData.append('upload', files[key])
          }
        }
      }
    } else if (files && files[0]) {
      formData.append('upload', files[0])
    }

    console.log('files')
    console.log(files)

    const request = {
      url: `${API_HOST}/controller/Event.asmx/updateEvent`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async getPtcParticipant(eventID) {
    const data = {
      eventID: eventID,
    }

    return await this.callWebService('/controller/Event.asmx/getPtcParticipant', data, 'POST')
  }

  async saveTimeslotBooking(eventTimeslotID, eventParID, eventID, eventHangoutLink, eventCalendarID) {
    const data = {
      eventTimeslotID: eventTimeslotID,
      eventParID: eventParID,
      eventID: eventID,
      eventHangoutLink: eventHangoutLink,
      eventCalendarID: eventCalendarID,
    }

    return await this.callWebService('/controller/Event.asmx/saveTimeslotBooking', data, 'POST')
  }

  async updateTimeslotBooking(eventTimeslotID, eventParID, eventID, eventHangoutLink, eventCalendarID) {
    const data = {
      eventTimeslotID: eventTimeslotID,
      eventID: eventID,
      eventHangoutLink: eventHangoutLink,
      eventCalendarID: eventCalendarID,
    }

    return await this.callWebService('/controller/Event.asmx/updateTimeSlotBooking', data, 'POST')
  }

  async saveScheduleStudentClass(scheduleStudentListJsonString) {
    const data = {
      scheduleStudentListJsonString: scheduleStudentListJsonString,
    }

    return await this.callWebService('/controller/Students.asmx/saveScheduleStudentClass', data, 'POST')
  }

  async getScheduleStudentClass() {
    const data = {}

    return await this.callWebService('/controller/Students.asmx/getScheduleStudentClass', data, 'POST')
  }

  async updateScheduleStudentClass(ClsSheID, mode) {
    const data = {
      ClsSheID: ClsSheID,
      mode: mode,
    }

    return await this.callWebService('/controller/Students.asmx/updateScheduleStudentClass', data, 'POST')
  }

  async getUnAssignStudentListFromBusScheduleByBusIDEffectiveDate(busType, effectiveDate) {
    const data = {
      busType: busType,
      effectiveDate: effectiveDate,
    }

    return await this.callWebService('/controller/Attendance.asmx/getUnAssignStudentListFromBusScheduleByBusIDEffectiveDate', data, 'POST')
  }

  async saveScheduleBusNo(scheduleStudentListJsonString) {
    const data = {
      scheduleStudentListJsonString: scheduleStudentListJsonString,
    }

    return await this.callWebService('/controller/Attendance.asmx/saveScheduleBusNo', data, 'POST')
  }

  async getScheduleBusNo() {
    const data = {}

    return await this.callWebService('/controller/Attendance.asmx/getScheduleBusNo', data, 'POST')
  }

  async updateScheduleusNo(BusSheID, mode) {
    const data = {
      BusSheID: BusSheID,
      mode: mode,
    }

    return await this.callWebService('/controller/Attendance.asmx/updateScheduleusNo', data, 'POST')
  }

  async getLibertyReport(inputDateFrom, inputDateTo) {
    const data = {
      dateFrom: inputDateFrom,
      dateTo: inputDateTo,
    }

    return await this.callWebService('/controller/Billing.asmx/getLibertyReport', data, 'POST')
  }

  async getLibertyReport2(inputDateFrom, inputDateTo) {
    const data = {
      dateFrom: inputDateFrom,
      dateTo: inputDateTo,
    }

    return await this.callWebService('/controller/Billing.asmx/getLibertyReport2', data, 'POST')
  }

  async getAllHistorySemesterAndSemesterDetailsByStudentID(studentID) {
    const data = {
      studentID: studentID,
    }

    return await this.callWebService('/controller/Students.asmx/getAllHistorySemesterAndSemesterDetailsByStudentID', data, 'POST')
  }

  async getPortfolioPostFile(postID, byPassToken) {
    const data = {
      postID: postID,
      byPassToken: byPassToken,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostFile', data, 'POST')
  }

  async saveWithdrawForm(Obj, WithdrawParentSignature, WithdrawOfficeUseSignature) {
    const data = {
      Obj: Obj,
      WithdrawParentSignature: WithdrawParentSignature,
      WithdrawOfficeUseSignature: WithdrawOfficeUseSignature,
    }

    return await this.callWebService('/controller/Parents.asmx/saveWithdrawForm', data, 'POST')
  }

  async getWithdrawFormDetail(classNameBatch, studentID, withdrawDate, isEncrypted, encrytedID, studentCourseID) {
    const data = {
      classNameBatch: classNameBatch,
      studentID: studentID,
      withdrawDate: withdrawDate,
      isEncrypted: isEncrypted,
      encrytedID: encrytedID,
      studentCourseID: studentCourseID,
    }

    return await this.callWebService('/controller/Parents.asmx/getWithdrawFormDetail', data, 'POST')
  }

  async approvePlanner(actionStatus, plannerApproverID, approverComment) {
    const data = {
      actionStatus: actionStatus,
      plannerApproverID: plannerApproverID,
      approverComment: approverComment,
    }

    return await this.callWebService('/controller/Portfolio.asmx/approvePlanner', data, 'POST')
  }

  async createGoogleCalendarEvent(creatorEmail, title, location, attendeeEmail, calStart, calEnd, randID, evtType, createType) {
    const data = {
      creatorEmail: creatorEmail,
      title: title,
      location: location,
      attendeeEmail: attendeeEmail,
      calStart: calStart,
      calEnd: calEnd,
      randID: randID,
      evtType: evtType,
      createType: createType,
    }

    const request = {
      url: `${API_HOST2}gmailaccount/createGoogleCalendarEvent`,
      data: JSON.stringify(data),
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      success: function (response) {
        return response
      },
    }

    console.log(data)
    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }

    return response
  }

  async deleteGoogleCalendarEvent(calEventID, attendeeEmail) {
    const data = {
      calEventID: calEventID,
      attendeeEmail: attendeeEmail,
    }

    const request = {
      url: `${API_HOST2}gmailaccount/deleteGoogleCalendarEvent`,
      data: JSON.stringify(data),
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }

    return response
  }

  async saveStudentWithdraw(obj) {
    const data = {
      obj: obj,
    }
    return await this.callWebService('/controller/Students.asmx/saveStudentWithdraw', data, 'POST')
  }

  async getStudentSiblingReport(type) {
    const data = {
      type: type,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentSiblingReport', data, 'POST')
  }

  async getPlannerAssignedStudentDetailsByAcademicYear(studentID, semID) {
    const data = {
      studentID: studentID,
      semID: semID,
    }
    return await this.callWebService('/controller/Portfolio.asmx/getPlannerAssignedStudentDetailsByAcademicYear', data, 'POST')
  }

  async getWithdrawDetailBySchoolID(mode) {
    const data = {
      mode: mode,
    }
    return await this.callWebService('/controller/Parents.asmx/getWithdrawDetailBySchoolID', data, 'POST')
  }

  async updateWithdrawDetailByID(withdrawID) {
    const data = {
      withdrawID: withdrawID,
    }
    return await this.callWebService('/controller/Parents.asmx/updateWithdrawDetailByID', data, 'POST')
  }

  async getStudentMovementReport(type, from_date, to_date) {
    const data = {
      type: type,
      from_date: from_date,
      to_date: to_date,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentMovementReport', data, 'POST')
  }

  async getPortfolioItemMaster(type, type2, classID) {
    const data = {
      type: type,
      type2: type2,
      classID: classID,
    }

    return await this.callWebService('/controller/Portfolio.asmx/getPortfolioItemMaster', data, 'POST')
  }

  async saveTravelDeclaration(jsonObj) {
    const data = {
      jsonDetails: jsonObj,
    }
    return await this.callWebService('/controller/Parents.asmx/saveParentTravelDeclaration', data, 'POST')
  }

  async getTravelDeclaration(parentID) {
    const data = {
      UserID_Session: parentID,
    }
    return await this.callWebService('/controller/Parents.asmx/getParentTravelDeclaration', data, 'POST')
  }

  async deleteTravelDeclaration(trdcID, mode, remarks) {
    const data = {
      trdcID: trdcID,
      mode: mode,
      remark: remarks,
    }
    return await this.callWebService('/controller/Parents.asmx/updateParentTravelDeclaration', data, 'POST')
  }

  async getTravelDeclarationReport(schoolID) {
    const data = {
      UserSelectSchool: schoolID,
    }
    return await this.callWebService('/controller/Parents.asmx/getJoinParentTravelDeclaration', data, 'POST')
  }

  async getNonTravelDeclarationReport(schoolID) {
    const data = {
      UserSelectSchool: schoolID,
    }
    return await this.callWebService('/controller/Parents.asmx/getJoinParentTravelNonDeclaration', data, 'POST')
  }

  async getPaymentDocumentZip(InvoiceName, studentID, isEncrypted, ID) {
    const data = {
      InvoiceName: InvoiceName,
      studentID: studentID,
      isEncrypted: isEncrypted,
      ID: ID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentDocumentZip', data, 'POST')
  }

  async getParentTravelUnDeclaration(UserSelectSchool) {
    const data = {
      UserSelectSchool: UserSelectSchool,
    }
    return await this.callWebService('/controller/Parents.asmx/getParentTravelUnDeclaration', data, 'POST')
  }

  async saveEndResult(files, eventID, remarks) {
    const formData = new FormData()
    formData.append('eventID', eventID)
    formData.append('remarks', remarks)
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('UserType_Session', Cookies.get('userTypeSession'))
    formData.append('UserUniversitySession', Cookies.get('userUniversitySession'))
    formData.append('UserEmailSession', Cookies.get('userEmailSession'))
    formData.append('USRidSession', Cookies.get('usRidSession'))
    formData.append('UserNameSession', Cookies.get('userNameSession'))

    if (files && files.length > 1) {
      for (let key in files) {
        if (files.hasOwnProperty(key)) {
          if (key > 0) {
            formData.append(`upload_${key}`, files[key])
          } else {
            formData.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      formData.append('upload', files[0])
    }
    const request = {
      url: `${API_HOST}/controller/Event.asmx/saveEventPostBack`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }
    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async getEventPostBack(eventID, mode) {
    const data = {
      eventID: eventID,
      mode: mode,
    }
    return await this.callWebService('/controller/Event.asmx/getEventPostBack', data, 'POST')
  }

  async getEventPostBackFile(eventPBID) {
    const data = {
      eventPBID: eventPBID,
    }
    return await this.callWebService('/controller/Event.asmx/getEventPostBackFile', data, 'POST')
  }

  async getAllEventPostBackZipFile(eventID, createdBy) {
    const data = {
      EventID: eventID,
      PostBackCreatedBy: createdBy,
    }
    return await this.callWebService('/controller/Event.asmx/getAllEventPostBackZipFile', data, 'POST')
  }

  async getPostFileReturnFilePath(postID) {
    const data = {
      postID: postID,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostFileReturnFilePath', data, 'POST')
  }

  async getServerCurrentDatetime() {
    const data = {}
    return await this.callWebService('/controller/Event.asmx/getCurrentDateTime', data, 'POST')
  }

  async saveRegistrationForm(parentID, Obj) {
    const data = {
      parentID: parentID,
      Obj: Obj,
    }
    return await this.callWebService('/controller/Register.asmx/saveRegistrationForm', data, 'POST')
  }

  async getRegistrationForm(parentID, regFormID) {
    const data = {
      parentID: parentID,
      regFormID: regFormID,
    }
    return await this.callWebService('/controller/Register.asmx/getRegistrationForm', data, 'POST')
  }

  async printStudentNameAndBarcode(obj, mode) {
    const data = {
      obj: obj,
      mode: mode,
    }
    return await this.callWebService('/controller/Class.asmx/printStudentNameAndBarcode', data, 'POST')
  }

  async getPortfolioMomentPost(int_NumberOfPost, str_LastPostID, studentID) {
    const data = {
      UserID_Session: Cookies.get('userIDSession'),
      numberOfPortfolio: int_NumberOfPost,
      lasPortfolioID: str_LastPostID,
      studentID: studentID,
    }
    return await this.callWebService('/controller/Portfolio.asmx/getPortfolioMomentPost', data, 'POST')
  }

  async getPostKeyTag(postID) {
    const data = {
      postID: postID,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostKeyTag', data, 'POST')
  }

  async getTermlyReportList(studentID, classID, dateFrom, dateTo, status) {
    const data = {
      studentID: studentID,
      classID: classID,
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: status,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/getTermlyReportList', data, 'POST')
  }

  async getTermlyReportPostList(studentID, classID) {
    const data = {
      studentID: studentID,
      classID: classID,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/getTermlyReportPostList', data, 'POST')
  }

  async saveTermlyReport(studentID, classID, header, content, domainComments, inviteTeacher, teacherApproverList) {
    const data = {
      studentID: studentID,
      classID: classID,
      header: header,
      content: content,
      domainComments: domainComments,
      inviteTeacher: inviteTeacher,
      teacherApproverList: teacherApproverList,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/saveTermlyReport', data, 'POST')
  }

  async getTermlyReport(termlyReportID) {
    const data = {
      termlyReportID: termlyReportID,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/getTermlyReport', data, 'POST')
  }

  async removeTeacherTermlyReport(termlyReportID, ConId) {
    const data = {
      termlyReportID: termlyReportID,
      ConId: ConId,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/removeTeacherTermlyReport', data, 'POST')
  }

  async checkTermlyReportFlow(termlyReportID, classID) {
    const data = {
      termlyReportID: termlyReportID,
      classID: classID,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/checkTermlyReportFlow', data, 'POST')
  }

  async saveTermlyReportComments(termlyReportID, domainComments, classID) {
    const data = {
      termlyReportID: termlyReportID,
      domainComments: domainComments,
      classID: classID,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/saveTermlyReportComments', data, 'POST')
  }

  async generateDownloadTermlyReportPDF(termlyReportID) {
    const data = {
      termlyReportID: termlyReportID,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/generateDownloadTermlyReportPDF', data, 'POST')
  }

  async getTermlyReportFlow(termlyReportID, classID) {
    const data = {
      termlyReportID: termlyReportID,
      classID: classID,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/getTermlyReportFlow', data, 'POST')
  }

  async getTermlyReportStudentInfoPart(studentID, classID) {
    const data = {
      studentID: studentID,
      classID: classID,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/getTermlyReportStudentInfoPart', data, 'POST')
  }

  async submitTermlyReport(termlyReportID) {
    const data = {
      termlyReportID: termlyReportID,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/submitTermlyReport', data, 'POST')
  }

  async signTermlyReportComments(termlyReportID, status) {
    const data = {
      termlyReportID: termlyReportID,
      status: status,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/signTermlyReportComments', data, 'POST')
  }

  async getStudentsWithTermlyReportByClassId(classId) {
    const data = {
      classId: classId,
    }

    return await this.callWebService('/controller/TermlyReport.asmx/getStudentsWithTermlyReportByClassId', data, 'POST')
  }

  async savePostDM(postID, toConID, msgContent, postLink) {
    const data = {
      postID: postID,
      toConID: toConID,
      msgContent: msgContent,
      postLink: postLink,
    }
    return await this.callWebService('/controller/Posting.asmx/savePostDirectMsg', data, 'POST')
  }

  async getDMHistoryChat() {
    const data = {}
    return await this.callWebService('/controller/Posting.asmx/getPostDirectMsgHistoryChatPersonList', data, 'POST')
  }

  async getDMPersonChat(dmWithConID) {
    const data = {
      dmWithConID: dmWithConID,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostDirectMsg', data, 'POST')
  }

  async deletePTCTimesolt(eventTimeslotID) {
    const data = {
      eventTimeslotID: eventTimeslotID,
    }
    return await this.callWebService('/controller/Event.asmx/deleteTimeSlotBooking', data, 'POST')
  }

  async getApplicationQuestion(schoolId = '') {
    const payload = {
      schoolId,
    }
    return await this.callWebService('/controller/Form.asmx/getApplicationQuestion', payload, 'POST')
  }

  async saveFileTest(files) {
    const formData = new FormData()
    formData.append('fileType', 'File')
    formData.append('ApplicationFormID', 'APF_ID')
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))

    if (files && files.length > 1) {
      for (let i = 0; i < files.length; i++) {
        formData.append('files' + i, files[i])
        formData.append('files' + i + '_UploadType', files[i].uploadType)
        console.log('files' + i + '_UploadType')
      }
    } else {
      formData.append('files', files[0])
      formData.append('files_UploadType', files[0].uploadType)
    }

    const request = {
      url: `${API_HOST}/controller/Form.asmx/testuploadFile`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }
    return await jQuery.ajax(request)
  }

  async saveApplicationAttachment(files, type) {
    const formData = new FormData()
    if (files && files.length > 1) {
      for (let key in files) {
        if (files.hasOwnProperty(key)) {
          if (key > 0) {
            formData.append(`Doc${Number(key) + 1}`, files[key])
            formData.append(`Doc${Number(key) + 1}_UploadType`, type)
          } else {
            formData.append('Doc1', files[key])
            formData.append(`Doc1_UploadType`, type)
          }
        }
      }
    } else if (files && files.length) {
      formData.append('Doc1', files[0])
      formData.append(`Doc1_UploadType`, type)
    } else {
      formData.append('Doc1', files)
      formData.append(`Doc1_UploadType`, type)
    }
    return await this.callWebService('/controller/Api.asmx/SaveApplicationAttachment', formData, 'POST', true, true)
  }

  async saveApplicationAttachmentToExistingForm(apfId, files, fileType) {
    const formData = new FormData()
    formData.append(`APF_ID`, apfId)
    formData.append(`UserID_Session`, Cookies.get('userIDSession'))
    formData.append(`APAT_UploadType`, fileType)
    for (let i = 0; i < files.length; i++) {
      formData.append(`files_${i}`, files[i])
    }
    return await this.callWebService('/controller/Api.asmx/SaveApplicationAttachment', formData, 'POST', true, true)
  }

  async saveApplicationForm(
    status,
    PrevAttachedFiles,
    files,
    StuObj,
    ParentObj,
    QNAObj,
    SiblingObj,
    DeclareObj,
    selectedSchID,
    applicationFormID,
    applicationFormParentID,
    currentStudentImageAPATID,
    apat_ids,
  ) {
    const formData = new FormData()
    formData.append('status', status)
    formData.append('PrevAttachedFiles', PrevAttachedFiles)
    formData.append('StuObj', StuObj)
    formData.append('ParentObj', ParentObj)
    formData.append('QNAObj', QNAObj)
    formData.append('SiblingObj', SiblingObj)
    formData.append('DeclareObj', DeclareObj)
    formData.append('selectedSchID', selectedSchID)
    formData.append('fileType', 'File')
    formData.append('token', Cookies.get('authToken'))
    formData.append('applicationFormID', applicationFormID)
    formData.append('applicationFormParentID', applicationFormParentID)
    formData.append('currentStudentImageAPATID', currentStudentImageAPATID)
    formData.append('apat_ids', apat_ids)

    return await this.callWebService('/controller/Api.asmx/SaveApplicationForm', formData, 'POST', true, true)
  }

  async getDraftApplicationForm(applicationFormID) {
    const data = {
      applicationFormID: applicationFormID,
    }
    return await this.callWebService('/controller/Form.asmx/getDraftApplicationForm', data, 'POST')
  }

  //todo: application list only
  async getApplicationList(schoolID) {
    const data = {
      schoolID: schoolID,
    }
    return await this.callWebService('/controller/Api.asmx/GetApplicationFormList', data, 'POST')
  }

  async saveWithdrawalForm({
    Date,
    StudentID,
    MainReason,
    School,
    SchoolDetails,
    Reason1,
    Reason2,
    Reason3,
    Reason1Text,
    Reason2Text,
    Reason3Text,
    StudentPass,
    BankAccountHolder,
    BankName,
    BankCode,
    BankAccount,
    Email,
    Contact,
    ParentName,
    ParentSignature,
    NoticeGiven,
    ExceptionRequest,
    ExceptionRequestDocs,
    CountryName,
    Improvement,
    SchoolType,
    RefundFeesPercentage,
    RefundFees,
    tempRemarksPL,
    RemarksPL,
    RemarksPrincipal,
    RemarksFinance,
    ID,
    CopyToAdmin,
    CopyToParents,
    CopyToBusProvider,
    UpdateToICA,
    UpdateClassList,
    InformClassTeacher,
    StudentName,
    FormType,
  }) {
    const formData = new FormData()
    Date && formData.append('Date', Date)
    StudentID && formData.append('StudentID', StudentID)
    MainReason && formData.append('MainReason', MainReason)
    School && formData.append('School', School)
    SchoolDetails && formData.append('SchoolDetails', SchoolDetails)
    SchoolType && formData.append('SchoolType', SchoolType)
    Reason1 && formData.append('Reason1', Reason1)
    Reason2 && formData.append('Reason2', Reason2)
    Reason3 && formData.append('Reason3', Reason3)
    Reason1Text && formData.append('Reason1Details', Reason1Text)
    Reason2Text && formData.append('Reason2Details', Reason2Text)
    Reason3Text && formData.append('Reason3Details', Reason3Text)
    CountryName && formData.append('CountryName', CountryName)
    Improvement && formData.append('Improvement', Improvement)
    StudentPass && formData.append('StudentPass', StudentPass)
    BankAccountHolder && formData.append('BankAccountHolder', BankAccountHolder)
    BankName && formData.append('BankName', BankName)
    BankCode && formData.append('BankCode', BankCode)
    BankAccount && formData.append('BankAccount', BankAccount)
    Email && formData.append('Email', Email)
    Contact && formData.append('Contact', Contact)
    ParentName && formData.append('ParentName', ParentName)
    StudentName && formData.append('StudentName', StudentName)
    ParentSignature && formData.append('ParentSignature', ParentSignature)
    FormType && formData.append('FormType', FormType)
    ExceptionRequest && formData.append('ExceptionRequest', ExceptionRequest)
    if (ExceptionRequest === 'yes') {
      ExceptionRequestDocs && formData.append('ExceptionRequestDocs', JSON.stringify(ExceptionRequestDocs))
    }
    RefundFeesPercentage && formData.append('RefundFeesPercentage', RefundFeesPercentage)
    RefundFees && formData.append('RefundFees', RefundFees)
    if (tempRemarksPL) {
      formData.append('RemarksPL', RemarksPL + '\n' + tempRemarksPL)
    } else if (RemarksPL) {
      formData.append('RemarksPL', RemarksPL)
    }
    RemarksPrincipal && formData.append('RemarksPrincipal', RemarksPrincipal)
    RemarksFinance && formData.append('RemarksFinance', RemarksFinance)
    ID && formData.append('ID', ID)
    CopyToAdmin && formData.append('CopyToAdmin', CopyToAdmin)
    CopyToParents && formData.append('CopyToParents', CopyToParents)
    CopyToBusProvider && formData.append('CopyToBusProvider', CopyToBusProvider)
    UpdateToICA && formData.append('UpdateToICA', UpdateToICA)
    UpdateClassList && formData.append('UpdateClassList', UpdateClassList)
    InformClassTeacher && formData.append('InformClassTeacher', InformClassTeacher)
    formData.append('NoticeGiven', NoticeGiven ?? '')
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('UserType_Session', Cookies.get('userTypeSession'))
    formData.append('UserUniversitySession', Cookies.get('userUniversitySession'))
    formData.append('UserEmailSession', Cookies.get('userEmailSession'))
    formData.append('USRidSession', Cookies.get('usRidSession'))
    formData.append('UserNameSession', Cookies.get('userNameSession'))

    return await this.callWebService('/controller/Api.asmx/SaveWithdrawalForm', formData, 'POST', true, true)
  }

  async getWithdrawalList() {
    const data = {}
    return await this.callWebService('/controller/Api.asmx/GetWithdrawalFormList', data, 'POST')
  }

  async getWithdrawalFormDetail(withdrawalFormID) {
    const data = {}
    return await this.callWebService('/controller/Api.asmx/GetWithdrawalForm?id=' + withdrawalFormID, data, 'GET')
  }

  async getStudentforWithdrawal(studentID, date) {
    const data = {}
    let params
    if (date) {
      params = 'id=' + studentID + '&classDate=' + date
    } else {
      params = 'id=' + studentID
    }
    return await this.callWebService('/controller/Api.asmx/GetStudent?' + params, data, 'GET')
  }

  async approveWithdrawalForm(FormID) {
    const data = {
      ConID: getUserID(),
      FormID: FormID,
      callIndex: generateRandomIndex(),
    }

    return await this.callWebService('/controller/Api.asmx/ApproveWithdrawalForm', data, 'POST')
  }

  async rejectWithdrawalForm(FormID) {
    const data = {
      ConID: getUserID(),
      FormID: FormID,
    }

    return await this.callWebService('/controller/Api.asmx/RejectWithdrawalForm', data, 'POST')
  }

  async deleteWithdrawalForm(FormID) {
    const data = {
      ConID: getUserID(),
      FormID: FormID,
    }

    return await this.callWebService('/controller/Api.asmx/DeleteWithdrawalForm', data, 'POST')
  }

  async sendWithdrawalFormNotifications(FormID) {
    const data = {
      ConID: getUserID(),
      FormID: FormID,
    }

    return await this.callWebService('/controller/Api.asmx/SendWithdrawalFormNotifications', data, 'POST')
  }

  async sendApplicationFormNotifications(APF_ID) {
    const data = {
      APF_ID: APF_ID,
    }

    return await this.callWebService('/controller/Api.asmx/SendApplicationFormNotifications', data, 'POST')
  }

  async sendWithdrawFormLinkToParent(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Api.asmx/SendWithdrawFormLinkToParent', data, 'POST')
  }

  async getPlannerProgressPost(itemID) {
    const data = {
      itemID: itemID,
    }
    return await this.callWebService('/controller/Portfolio.asmx/getPlannerProgressPost', data, 'POST')
  }

  async savePortfolio(mode, studentID, portfolioTitle, portfolioEditID, portfolioTemplateHtml, portfolioTemplateCss, learningMoments) {
    const data = {
      portfolioEditID: portfolioEditID,
      mode: mode,
      studentID: studentID,
      portfolioTitle: portfolioTitle,
      portfolioTemplateHtml: portfolioTemplateHtml,
      portfolioTemplateCss: portfolioTemplateCss,
      learningMoments: learningMoments,
    }

    return await this.callWebService('/controller/Portfolio.asmx/savePortfolio', data, 'POST')
  }

  async getTermlyReportInfoByLink(termlyReportID) {
    const data = {
      termlyReportID: termlyReportID,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/getTermlyReportInfoByLink', data, 'POST')
  }

  async donwloadPlannerAssignedStudent(objectItem) {
    const data = {
      objectItem: objectItem,
    }
    return await this.callWebService('/controller/Portfolio.asmx/donwloadPlannerAssignedStudent', data, 'POST')
  }

  async updateUserConfiguration(objectItem) {
    const data = {
      objectItem: objectItem,
    }
    return await this.callWebService('/controller/User.asmx/updateUserConfiguration', data, 'POST')
  }

  async getUserConfigurationValueByType(typeJsonString) {
    const data = {
      typeJsonString: typeJsonString,
    }
    return await this.callWebService('/controller/User.asmx/getUserConfigurationValueByType', data, 'POST')
  }

  async getPostDevelopmentGoals(postID) {
    const data = {
      postID: postID,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostLearningMoment', data, 'POST')
  }

  async getPostSeen(postID) {
    const data = {
      postID: postID,
    }
    return await this.callWebService('/controller/Posting.asmx/getPostSeen', data, 'POST')
  }

  async getStudentTravelDeclaration(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentTravelDeclaration', data, 'POST')
  }

  async saveIncidentForm(files, schoolID, Obj, TeacherSignObj, parentSelectedObj) {
    const formData = new FormData()
    formData.append('Obj', Obj)
    formData.append('TeacherSignObj', TeacherSignObj)
    formData.append('parentSelectedObj', parentSelectedObj)
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('UserType_Session', Cookies.get('userTypeSession'))
    formData.append('UserUniversitySession', Cookies.get('userUniversitySession'))
    formData.append('UserEmailSession', Cookies.get('userEmailSession'))
    formData.append('USRidSession', Cookies.get('usRidSession'))
    formData.append('UserNameSession', Cookies.get('userNameSession'))
    if (files && files.length > 1) {
      for (let key in files) {
        if (files.hasOwnProperty(key)) {
          if (key > 0) {
            formData.append(`upload_${key}`, files[key])
          } else {
            formData.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      formData.append('upload', files[0])
    }
    const request = {
      url: `${API_HOST}/controller/Form.asmx/saveIncidentForm`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }
    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async getIncidentForm(IncidentFormID) {
    const data = {
      IncidentFormID: IncidentFormID,
    }
    return await this.callWebService('/controller/Form.asmx/getIncidentForm', data, 'POST')
  }

  async approveIncidentForm(IncidentID, IncidentLogID, ApproveReason) {
    const data = {
      IncidentID: IncidentID,
      IncidentLogID: IncidentLogID,
      ApproveReason: ApproveReason,
    }
    return await this.callWebService('/controller/Form.asmx/approveIncidentForm', data, 'POST')
  }

  async rejectIncidentForm(IncidentID, IncidentLogID, RejectReason) {
    const data = {
      IncidentID: IncidentID,
      IncidentLogID: IncidentLogID,
      RejectReason: RejectReason,
    }
    return await this.callWebService('/controller/Form.asmx/rejectIncidentForm', data, 'POST')
  }

  async appealIncidentForm(files, IncidentID, IncidentLogID, UpdateAppealObj) {
    const formData = new FormData()
    formData.append('IncidentID', IncidentID)
    formData.append('IncidentLogID', IncidentLogID)
    formData.append('UpdateAppealObj', UpdateAppealObj)
    formData.append('token', Cookies.get('authToken'))
    formData.append('UserID_Session', Cookies.get('userIDSession'))
    formData.append('UserSchool_Session', Cookies.get('schoolSession'))
    formData.append('UserType_Session', Cookies.get('userTypeSession'))
    formData.append('UserUniversitySession', Cookies.get('userUniversitySession'))
    formData.append('UserEmailSession', Cookies.get('userEmailSession'))
    formData.append('USRidSession', Cookies.get('usRidSession'))
    formData.append('UserNameSession', Cookies.get('userNameSession'))
    if (files && files.length > 1) {
      for (let key in files) {
        if (files.hasOwnProperty(key)) {
          if (key > 0) {
            formData.append(`upload_${key}`, files[key])
          } else {
            formData.append('upload', files[key])
          }
        }
      }
    } else if (files) {
      formData.append('upload', files[0])
    }
    const request = {
      url: `${API_HOST}/controller/Form.asmx/appealIncidentForm`,
      cache: false,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }
    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    return response
  }

  async generateIncidentPDF(IncidentID) {
    const data = {
      IncidentID: IncidentID,
    }
    return await this.callWebService('/controller/Form.asmx/generateIncidentPDF', data, 'POST')
  }

  async getIncidentList(schoolID) {
    const data = {
      schoolID: schoolID,
    }
    return await this.callWebService('/controller/Form.asmx/getIncidentList', data, 'POST')
  }

  async getIncidentFileDetail(IncidentID) {
    const data = {
      IncidentID: IncidentID,
    }
    return await this.callWebService('/controller/Form.asmx/getIncidentFileDetail', data, 'POST')
  }

  async cancelIncidentForm(IncidentID, cancelReason) {
    const data = {
      IncidentID: IncidentID,
      cancelReason: cancelReason,
    }
    return await this.callWebService('/controller/Form.asmx/cancelIncidentForm', data, 'POST')
  }

  async updateLevel(scrID, mode, voidReasons) {
    const data = {
      scrID: scrID,
      mode: mode,
      voidReasons: voidReasons,
    }
    return await this.callWebService('/controller/Course.asmx/updateLevel', data, 'POST')
  }

  async updateLevelClass(scrID, mode, voidReasons, newlevel, newclass, newstartdate, newAcademicYear) {
    const data = {
      scrID: scrID,
      mode: mode,
      voidReasons: voidReasons,
      newlevel: newlevel,
      newclass: newclass,
      newstartdate: newstartdate,
      newAcademicYear,
    }
    return await this.callWebService('/controller/Course.asmx/updateLevelClass', data, 'POST')
  }

  async getInvoicListPT(type, studentID) {
    const data = {
      type: type,
      studentID: studentID,
    }
    return await this.callWebService('/controller/Billing.asmx/getInvoicListPT', data, 'POST')
  }

  async getPowerbiEmbedAgingReport() {
    const request = {
      url: `${API_HOST2}/powerbi/EmbedAgingReport`,
      data: JSON.stringify({}),
      cache: false,
      type: 'POST',
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      async: false,
      json: false,
      success: function (response) {
        return response
      },
    }

    let response = await jQuery.ajax(request)
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }

    return response
  }

  async getCreateTermlyClassTeacher(classID) {
    const data = {
      id: classID,
    }
    return await this.callWebService('/controller/Api.asmx/GetClass', data, 'POST')
  }

  async getTermlyReportDomainMapping() {
    const data = {}
    return await this.callWebService('/controller/TermlyReport.asmx/getTermlyReportDomainMapping', data, 'POST')
  }

  async updateAttendanceListWithTemperatureNew(deviceOutput, student_Index, temprature, inOut, remark) {
    const data = {
      deviceOutput: deviceOutput,
      student_Index: student_Index,
      temprature: temprature,
      inOut: inOut,
      remark: remark,
    }

    return await this.callWebService('/controller/Attendance.asmx/updateAttendanceListWithTemperature', data, 'POST')
  }

  async getSystemValue(appType) {
    const data = {
      appType: appType,
    }
    return await this.callWebService('/controller/General.asmx/getSystemValue', data, 'POST')
  }

  async updateTermlyReport(termlyReportID, mode) {
    const data = {
      termlyReportID: termlyReportID,
      mode: mode,
    }
    return await this.callWebService('/controller/TermlyReport.asmx/updateTermlyReport', data, 'POST')
  }

  async getStudentCurrentClassMate(studentID) {
    const data = {
      studentID: studentID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentCurrentClassMate', data, 'POST')
  }

  async getDailyRoutineByStudentIDwithDate(studentID, selectedDate) {
    const data = {
      studentID: studentID,
      selectedDate: selectedDate,
    }

    return await this.callWebService('/controller/Daily_Routine.asmx/getKgm_DailyRoutineByDate', data, 'POST')
  }

  async getStudentFileParentID(fileID) {
    const data = {
      fileID: fileID,
    }

    return await this.callWebService('/controller/Students.asmx/getStudentFileParentID', data, 'POST')
  }

  async getUserLatestGroupPostKeyTag(noPostKeyTag) {
    const data = {
      noPostKeyTag: noPostKeyTag,
    }

    return await this.callWebService('/controller/Posting.asmx/getUserLatestGroupPostKeyTag', data, 'POST')
  }

  async getClassCoordinator() {
    const data = {}

    return await this.callWebService('/controller/Class.asmx/getClassCoordinator', data, 'POST')
  }

  async updateClassCoordinator(list) {
    const data = {
      list: list,
    }

    return await this.callWebService('/controller/Class.asmx/updateClassCoordinator', data, 'POST')
  }

  async publishTermlyReport(termlyReportID) {
    const data = {
      termlyReportID: termlyReportID,
    }

    return await this.callWebService('/controller/TermlyReport.asmx/publishTermlyReport', data, 'POST')
  }

  async getPublishedTermlyReport(numberOfTermlyReport, lastTermlyReportID, mode) {
    const data = {
      numberOfTermlyReport: numberOfTermlyReport,
      lastTermlyReportID: lastTermlyReportID,
      mode: mode,
    }

    return await this.callWebService('/controller/TermlyReport.asmx/getPublishedTermlyReport', data, 'POST')
  }

  async updateTermlyReportCommentsByApproval(termlyReportID, termlyReportCommentID, editTermlyReportComment) {
    const data = {
      termlyReportID: termlyReportID,
      termlyReportCommentID: termlyReportCommentID,
      editTermlyReportComment: editTermlyReportComment,
    }

    return await this.callWebService('/controller/TermlyReport.asmx/updateTermlyReportCommentsByApproval', data, 'POST')
  }

  async getCardUpURL(invoiceName, studentID, totalAmount, isEncrypted, ID) {
    const data = {
      invoiceName: invoiceName,
      studentID: studentID,
      totalAmount: totalAmount,
      isEncrypted: isEncrypted,
      ID: ID,
    }
    return await this.callWebService('/controller/Billing.asmx/getCardUpURL', data, 'POST')
  }

  async getSchoolDropdownList(universityID) {
    const data = {
      universityID: universityID,
    }
    return await this.callWebService('/controller/UserMagt.asmx/getSchoolDropdownList', data, 'POST')
  }

  async getSchoolDropdownListByUser(universityID) {
    let conUserId = Cookies.get('userIDSession')

    const data = {
      universityID: universityID,
      conUserId: conUserId,
    }
    return await this.callWebService('/controller/UserMagt.asmx/getSchoolDropdownListByUser', data, 'POST')
  }

  async getSchoolGroupDropdownListByUser(universityID) {
    let conUserId = Cookies.get('userIDSession')

    const data = {
      universityID: universityID,
      conUserId: conUserId,
    }
    return await this.callWebService('/controller/UserMagt.asmx/getSchoolGroupDropdownList', data, 'POST')
  }

  async getEmployeeTypeDropdownList() {
    const data = {}

    return await this.callWebService('/controller/UserMagt.asmx/getEmployeeTypeDropdownList', data, 'POST')
  }

  async getTermlyReportPendingActionList() {
    const data = {}

    return await this.callWebService('/controller/TermlyReport.asmx/getTermlyReportPendingActionList', data, 'POST')
  }

  async createNewStaffAccount(Obj) {
    const data = {
      Obj: Obj,
    }
    return await this.callWebService('/controller/UserMagt.asmx/saveNewStaffAccount', data, 'POST')
  }

  async getUserListBySchool(SchoolID, Status, CONnameLike) {
    const data = {
      SchoolID: SchoolID,
      Status: Status,
      CONnameLike: CONnameLike,
    }
    return await this.callWebService('/controller/UserMagt.asmx/getUserListBySchool', data, 'POST')
  }

  async getUserDetailsWithSchoolNameByCONID(conID, schoolID, conEmail) {
    const data = {
      conID: conID,
      schoolID: schoolID,
      conEmail: conEmail,
    }
    return await this.callWebService('/controller/UserMagt.asmx/getUserDetailsWithSchoolNameByCONID', data, 'POST')
  }

  async getUserGroupByUSRID(usrID) {
    const data = {
      usrID: usrID,
    }
    return await this.callWebService('/controller/UserMagt.asmx/getUserGroupByUSRID', data, 'POST')
  }

  async updateStaffAccountStatus(Obj, status) {
    const data = {
      Obj: Obj,
      status: status,
    }
    return await this.callWebService('/controller/UserMagt.asmx/updateStaffAccountStatus', data, 'POST')
  }

  async assignUserGroup(Obj, staffUSRid) {
    const data = {
      Obj: Obj,
      staffUSRid: staffUSRid,
    }
    return await this.callWebService('/controller/UserMagt.asmx/assignUserGroup', data, 'POST')
  }

  async getUserSchoolByCONEmail(CONEmail, CONStatus) {
    const data = {
      CONEmail: CONEmail,
      CONStatus: CONStatus,
    }
    return await this.callWebService('/controller/UserMagt.asmx/getUserSchoolByCONEmail', data, 'POST')
  }

  async getStudentsEmailBySchool() {
    const data = {}

    return await this.callWebService('/controller/Students.asmx/getStudentsEmailBySchool', data, 'POST')
  }

  async getApplicationFormDetail(applicationFormID) {
    const data = {
      applicationFormID: applicationFormID,
    }
    return await this.callWebService('/controller/Api.asmx/GetApplicationFormList', data, 'POST')
  }

  async approveOrRejectApplicationForm(APMD_ID, APF_ID, mode, reason, additionalData) {
    const data = {
      APMD_ID: APMD_ID,
      APF_ID: APF_ID,
      mode: mode,
      reason: reason,
      ...additionalData,
    }
    return await this.callWebService('/controller/Api.asmx/ApproveOrRejectApplicationForm', data, 'POST')
  }

  async verifyEmailForApplicationForm(VerificationEmail, encryptedID) {
    const data = {
      VerificationEmail: VerificationEmail,
      encryptedID: encryptedID,
    }
    return await this.callWebService('/controller/Form.asmx/verifyEmailForApplicationForm', data, 'POST')
  }

  async getCountryListWithoutToken() {
    const data = {}
    return await this.callWebService('/controller/Form.asmx/getCountryListWithoutToken', data, 'POST')
  }

  async updateUserDetail(conID, usrID, usrLoginID, obj) {
    const data = {
      conID: conID,
      usrID: usrID,
      usrLoginID: usrLoginID,
      obj: obj,
    }
    return await this.callWebService('/controller/UserMagt.asmx/updateUserAccountDetail', data, 'POST')
  }

  async updateUserLoginDetail(conID, usrID, usrLoginID, pass) {
    const data = {
      conID: conID,
      usrID: usrID,
      usrLoginID: usrLoginID,
      pass: pass,
    }
    return await this.callWebService('/controller/UserMagt.asmx/updateUserLoginDetail', data, 'POST')
  }

  async getParentRegisterStatusReport() {
    const data = {}

    return await this.callWebService('/controller/Register.asmx/getParentRegisterStatusReport', data, 'POST')
  }

  async saveCovid19Declaration(jsonObj) {
    const data = {
      jsonDetails: jsonObj,
    }
    return await this.callWebService('/controller/Parents.asmx/saveParentCovidDeclaration', data, 'POST')
  }

  async getCovid19Declaration() {
    return await this.callWebService('/controller/Parents.asmx/getParentCovidDeclaration', {}, 'POST')
  }

  async deleteCovid19Declaration(cvdcID, mode, remarks) {
    const data = {
      cvdcID: cvdcID,
      mode: mode,
      remark: remarks,
    }
    return await this.callWebService('/controller/Parents.asmx/updateParentCovidDeclaration', data, 'POST')
  }

  async getAutoAssignLevelAcademicYear(commencementDate, dateOfBirth, selectedSchoolID) {
    const data = {
      selectedSchoolID: selectedSchoolID,
      commencementDate: commencementDate,
      dateOfBirth: dateOfBirth,
    }
    return await this.callWebService('/controller/Api.asmx/GetAutoAssignLevelAcademicYear', data, 'POST')
  }

  async getParentStudentsInfoWithMode(parentID, mode) {
    const data = {
      parentID: parentID,
      mode: mode,
    }
    return await this.callWebService('/controller/Parents.asmx/getParentStudentsInfo', data, 'POST')
  }

  async getParentCovidDeclarationReport() {
    const data = {}
    return await this.callWebService('/controller/Parents.asmx/getParentCovidDeclarationReport', data, 'POST')
  }

  async changeParentEmail(secretKey, fromEmail, toEmail) {
    const data = {
      secretKey: secretKey,
      fromEmail: fromEmail,
      toEmail: toEmail,
    }
    return await this.callWebService('/controller/Secret_Admin_Config_Token.asmx/changeParentEmail ', data, 'POST')
  }

  async getAttendanceListViewClass() {
    const data = {}
    return await this.callWebService('/controller/Attendance.asmx/getAttendanceListViewClass ', data, 'POST')
  }

  async getFolderZipFiles(galID) {
    const data = {
      galID: galID,
    }
    return await this.callWebService('/controller/Gallery.asmx/getFolderZipFiles', data, 'POST')
  }

  async getUserDetailsByCONID(conID) {
    const data = {
      conID: conID,
    }
    return await this.callWebService('/controller/User.asmx/getUserDetailsByCONID', data, 'POST')
  }

  async SendEmailBcc(str_EmailSubject, str_InnerHTML, lst_StudentID, lst_EmailGroupType, str_EmailFrom, str_AddEmailtoBCC) {
    const data = {
      str_EmailSubject: str_EmailSubject,
      str_InnerHTML: str_InnerHTML,
      lst_StudentID: lst_StudentID,
      lst_EmailGroupType: lst_EmailGroupType,
      str_EmailFrom: str_EmailFrom,
      str_AddEmailtoBCC: str_AddEmailtoBCC,
    }
    return await this.callWebService('/controller/EmailSend.asmx/SendEmailBcc', data, 'POST')
  }

  async getLoadTemplate(mode, postStatus, numberOfPost) {
    const data = {
      mode,
      postStatus,
      numberOfPost,
    }
    return await this.callWebService('/controller/Posting.asmx/getLoadTemplate', data, 'POST')
  }

  async getClassList() {
    const data = {}
    return await this.callWebService('/controller/Planner.asmx/GetClassList', data, 'POST')
  }

  async getDomainList(level) {
    const data = {
      level: level,
    }
    return await this.callWebService('/controller/Planner.asmx/GetDomainList', data, 'POST')
  }

  async getLevelList(schID) {
    const data = {
      schID: schID,
    }
    return await this.callWebService('/controller/Planner.asmx/GetLeveList', data, 'POST')
  }

  async insertCustomGoal(customGoalDomain, customGoalGoal, customGoalIndicator) {
    const data = {
      domain: customGoalDomain,
      goal: customGoalGoal,
      indicator: customGoalIndicator,
    }
    return await this.callWebService('/controller/Planner.asmx/insertCustomGoal', data, 'POST')
  }

  async fetchCustomGoals(customGoalDomain, customGoalGoal) {
    const data = {
      domain: customGoalDomain,
      goal: customGoalGoal,
    }
    return await this.callWebService('/controller/Planner.asmx/fetchCustomGoals', data, 'POST')
  }

  async saveCustomPlannerAssignedToCourse(newPlannerAssignedToCourseObjJson) {
    const data = {
      newPlannerAssignedToCourseObjJson: newPlannerAssignedToCourseObjJson,
    }
    return await this.callWebService('/controller/Planner.asmx/saveCustomPlannerAssignedToCourse', data, 'POST')
  }

  async getCustomPlannerAssignedToLevel(crsID, semdID) {
    const data = {
      crsID: crsID,
      semdID: semdID,
    }
    return await this.callWebService('/controller/Planner.asmx/getCustomPlannerAssignedToLevel', data, 'POST')
  }

  async getCustomPlannerAssignedToClass(crsID, clsId, semdID) {
    const data = {
      crsID: crsID,
      clsId: clsId,
      semdID: semdID,
    }
    return await this.callWebService('/controller/Planner.asmx/getCustomPlannerAssignedToClass', data, 'POST')
  }

  async getCustomPlannerAssignedToStudent(crsID, clsId, studID, semdID) {
    const data = {
      crsID: crsID,
      clsId: clsId,
      studID: studID,
      semdID: semdID,
    }
    return await this.callWebService('/controller/Planner.asmx/getCustomPlannerAssignedToStudent', data, 'POST')
  }

  async getSaveCustomGoalList(Term1GoalsList, Term2GoalsList, Term3GoalsList, Term4GoalsList) {
    const data = {
      Term1GoalsList: Term1GoalsList,
      Term2GoalsList: Term2GoalsList,
      Term3GoalsList: Term3GoalsList,
      Term4GoalsList: Term4GoalsList,
    }
    return await this.callWebService('/controller/Planner.asmx/getSaveCustomGoalList', data, 'POST')
  }

  async saveCustomPlannerAssignedToClass(newPlannerAssignedToClassObjJson) {
    const data = {
      newPlannerAssignedToClassObjJson: newPlannerAssignedToClassObjJson,
    }
    return await this.callWebService('/controller/Planner.asmx/saveCustomPlannerAssignedToClass', data, 'POST')
  }

  async saveCustomPlannerAssignedToStudent(newPlannerAssignedToStudentObjJson) {
    const data = {
      newPlannerAssignedToStudentObjJson: newPlannerAssignedToStudentObjJson,
    }
    return await this.callWebService('/controller/Planner.asmx/saveCustomPlannerAssignedToStudent', data, 'POST')
  }

  async getRoleConfigurationByUSRID(configurationType) {
    const data = {
      configurationType: configurationType,
    }
    return await this.callWebService('/controller/UserMagt.asmx/getRoleConfigurationByUSRID', data, 'POST')
  }

  async getNewsfeedStatsByTeacher(teacherName, schoolId, semesterId, courseId, classId, dates, limit, page) {
    const data = {
      teacherName: teacherName,
      schoolId: schoolId,
      semesterId: semesterId,
      courseId: courseId,
      classId: classId,
      limit: limit,
      dates: dates,
      page: page,
    }
    return await this.callWebService('/controller/Api.asmx/GetNewsfeedStatsByTeacher', data, 'POST')
  }

  async getUsers(params = {}) {
    return await this.callWebService('/controller/Api.asmx/GetUsers', params, 'POST')
  }

  async CreateStudentFromApplicationForm(apfId) {
    return await this.callWebService('/controller/Api.asmx/CreateStudentFromApplicationForm', { APF_ID: apfId }, 'POST')
  }

  async DeleteStudentFromApplicationForm(studentId) {
    return await this.callWebService('/controller/Api.asmx/DeleteStudentFromApplicationForm', { STUDENT_ID: studentId }, 'POST')
  }

  async GetAttendanceReport(fromDate, toDate, schoolId, studentType) {
    return await this.callWebService(
      '/controller/Api.asmx/GetAttendanceReportData',
      {
        fromDate: fromDate,
        toDate: toDate,
        schoolId: schoolId,
        studentType: studentType,
      },
      'POST',
    )
  }

  async GetDailyAttendanceReportData(fromDate, toDate, schoolId, studentType) {
    return await this.callWebService(
      '/controller/Api.asmx/GetDailyAttendanceReportData',
      {
        fromDate: fromDate,
        toDate: toDate,
        schoolId: schoolId,
        studentType: studentType,
      },
      'POST',
    )
  }

  async GetWithdrawReport(fromDate, toDate, schoolId) {
    return await this.callWebService(
      '/controller/Api.asmx/GetWithdrawReport',
      {
        fromDate: fromDate,
        toDate: toDate,
        schoolId: schoolId,
      },
      'POST',
    )
  }

  async GetEnrolReport(fromDate, toDate, schoolId) {
    return await this.callWebService(
      '/controller/Api.asmx/GetEnrolReport',
      {
        fromDate: fromDate,
        toDate: toDate,
        schoolId: schoolId,
      },
      'POST',
    )
  }

  async getStudentMeals(studentID, studentCourseID) {
    const data = {
      StudentID: studentID,
      StudentCourseID: studentCourseID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentMealByStudentId', data, 'POST')
  }

  async saveStudentMeal(newSchoolMeal) {
    const data = {
      studentID: newSchoolMeal.studentID,
      studentCourseID: newSchoolMeal.studentCourseID,
      courseFeeDetailID: newSchoolMeal.courseFeeDetailID,
      courseFeeSchemeID: newSchoolMeal.courseFeeSchemeID,
      mealStartDate: moment(newSchoolMeal.startDate).format('Y-MM-DD HH:mm:ss'),
      mealEndDate: moment(newSchoolMeal.endDate).format('Y-MM-DD HH:mm:ss'),
      mealRemarks: newSchoolMeal.remarks,
      overwriteStartDate: newSchoolMeal.overwriteStartDate,
      isStartDateOverwrite: newSchoolMeal.isStartDateOverwrite,
    }

    return await this.callWebService('/controller/Students.asmx/saveStudentMeal', data, 'POST')
  }

  async updateStudentMeal(newSchoolMeal) {
    const data = {
      studentID: newSchoolMeal.studentID,
      studentMealID: newSchoolMeal.studentMealID,
      mealStartDate: moment(newSchoolMeal.startDate).format('Y-MM-DD HH:mm:ss'),
      mealEndDate: moment(newSchoolMeal.endDate).format('Y-MM-DD HH:mm:ss'),
      mealRemarks: newSchoolMeal.remarks,
      actionMode: newSchoolMeal.actionMode,
    }

    return await this.callWebService('/controller/Students.asmx/updateStudentMeal', data, 'POST')
  }

  async getAddLang(studentID, studentCourseID) {
    const data = {
      StudentID: studentID,
      StudentCourseID: studentCourseID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentAddLangByStudentId', data, 'POST')
  }

  async saveAddLang(newAddLang) {
    const data = {
      studentID: newAddLang.studentID,
      studentCourseID: newAddLang.studentCourseID,
      courseFeeDetailID: newAddLang.courseFeeDetailID,
      courseFeeSchemeID: newAddLang.courseFeeSchemeID,
      stuAddLangStartDate: moment(newAddLang.startDate).format('Y-MM-DD HH:mm:ss'),
      stuAddLangEndDate: moment(newAddLang.endDate).format('Y-MM-DD HH:mm:ss'),
      stuAddLangRemarks: newAddLang.remarks,
      overwriteStartDate: newAddLang.overwriteStartDate,
      isStartDateOverwrite: newAddLang.isStartDateOverwrite,
    }

    return await this.callWebService('/controller/Students.asmx/saveStudentAddLang', data, 'POST')
  }

  async updateAddLang(newAddLang) {
    const data = {
      studentID: newAddLang.studentID,
      studentMealID: newAddLang.studentMealID,
      studentAddLangID: newAddLang.studentAddLangID,
      stuAddLangStartDate: moment(newAddLang.startDate).format('Y-MM-DD HH:mm:ss'),
      stuAddLangEndDate: moment(newAddLang.endDate).format('Y-MM-DD HH:mm:ss'),
      stuAddLangRemarks: newAddLang.remarks,
      actionMode: newAddLang.actionMode,
    }

    return await this.callWebService('/controller/Students.asmx/updateStudentAddLang', data, 'POST')
  }

  async getFeeDetailsOptionList(studentID, courseID, semesterID, listType) {
    const data = {
      studentID: studentID,
      courseID: courseID,
      semesterID: semesterID,
      listType: listType,
    }
    return await this.callWebService('/controller/Students.asmx/getFeeDetailsOptionList', data, 'POST')
  }

  async LoadStudentMealList(schID, semesterID, courseID, termID, classID) {
    const data = {
      schID: schID,
      semesterID: semesterID,
      courseID: courseID,
      termID: termID,
      classID: classID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentMealList', data, 'POST')
  }

  async LoadStudentAddLangList(schID, semesterID, courseID, termID, classID) {
    const data = {
      schID: schID,
      semesterID: semesterID,
      courseID: courseID,
      termID: termID,
      classID: classID,
    }
    return await this.callWebService('/controller/Students.asmx/getStudentAddLangList', data, 'POST')
  }

  async getUniversity(universityID, universityCode) {
    const data = {
      universityID: universityID,
      universityCode: universityCode,
    }
    return await this.callWebService('/controller/Operations.asmx/getAllUniversity', data, 'POST')
  }

  async getPaymentPlanMasterBySchId(schID) {
    const data = {
      schID: schID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentPlanMasterBySchId', data, 'POST')
  }

  async saveSemester(semID, schID, name, startDate, endDate, duration, status) {
    const data = {
      schID: schID,
      semID: semID,
      name: name,
      startDate: startDate,
      endDate: endDate,
      status: status,
      duration: duration,
    }
    return await this.callWebService('/controller/Course.asmx/updateAcademicYear', data, 'POST')
  }

  async saveSemesterDetail(semDetailID, semDetailStatus, semID, name, startDate, endDate, status) {
    const data = {
      semDetailID: semDetailID,
      semDetailStatus: semDetailStatus,
      semID: semID,
      name: name,
      startDate: startDate,
      endDate: endDate,
      status: status,
    }
    return await this.callWebService('/controller/Course.asmx/updateAcademicYearDetails', data, 'POST')
  }

  async saveFeeMaster(
    feeMasterID,
    schID,
    feeMasterName,
    courseID,
    feeMasterGst,
    feeMasterCurrency,
    semID,
    feeMasterClassType,
    feeMasterStatus,
    feeMasterStartDate,
    feeMasterEndDate,
  ) {
    const data = {
      feeMasterID: feeMasterID,
      schID: schID,
      feeMasterName: feeMasterName,
      courseID: courseID,
      feeMasterGst: feeMasterGst,
      feeMasterCurrency: feeMasterCurrency,
      semID: semID,
      feeMasterClassType: feeMasterClassType,
      feeMasterStatus: feeMasterStatus,
      feeMasterStartDate: feeMasterStartDate,
      feeMasterEndDate: feeMasterEndDate,
    }
    return await this.callWebService('/controller/Billing.asmx/saveFeeMaster', data, 'POST')
  }

  async saveSchoolBasicInfo(jsonString) {
    const data = {
      jsonString: jsonString,
    }
    return await this.callWebService('/controller/Operations.asmx/saveSchoolBasicInfo', data, 'POST')
  }

  async getPaymentPlanRulesByFKId(PPR_FK_Course_FEE_Detail_ID) {
    const data = {
      PPR_FK_Course_FEE_Detail_ID: PPR_FK_Course_FEE_Detail_ID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentPlanRulesByFKId', data, 'POST')
  }

  async savePaymentPlanRules(paymentPlan) {
    const data = {
      PPR_FK_School_ID: paymentPlan.PPR_FK_School_ID,
      PPR_Name: paymentPlan.PPR_Name,
      PPR_Category: paymentPlan.PPR_Category,
      PPR_Value: paymentPlan.PPR_Value,
      PPR_Unit: paymentPlan.PPR_Unit,
      PPR_ClassType: paymentPlan.PPR_ClassType,
      PPR_Timeline: paymentPlan.PPR_Timeline,
      PPR_FK_Course_ID: paymentPlan.PPR_FK_Course_ID,
      PPR_FK_Course_FEE_Detail_ID: paymentPlan.PPR_FK_Course_FEE_Detail_ID,
      PK_PPR_ID: paymentPlan.PK_PPR_ID,
      PPR_Status: paymentPlan.PPR_Status,
    }
    return await this.callWebService('/controller/Billing.asmx/savePaymentPlanRules', data, 'POST')
  }

  async getPaymentPlanMasterDetailsById(feeMasterID) {
    const data = {
      feeMasterID: feeMasterID,
    }
    return await this.callWebService('/controller/Billing.asmx/getPaymentPlanMasterDetailsById', data, 'POST')
  }

  async saveFeeDetail(paymentPlanDetail) {
    const data = {
      PK_Course_Fee_Detail_ID: paymentPlanDetail.PK_Course_Fee_Detail_ID,
      FK_Course_Fee_Scheme_ID: paymentPlanDetail.FK_Course_Fee_Scheme_ID,
      PPD_PaymentTimeline: paymentPlanDetail.PPD_PaymentTimeline,
      PPD_PaymentItemType: paymentPlanDetail.PPD_PaymentItemType,
      PPD_CalCategory: paymentPlanDetail.PPD_CalCategory,
      FK_Semester_Details_ID: paymentPlanDetail.FK_Semester_Details_ID,
      PPD_Payee_Name: paymentPlanDetail.PPD_Payee_Name,
      PPD_Amount: paymentPlanDetail.PPD_Amount,
    }
    return await this.callWebService('/controller/Billing.asmx/saveFeeDetail', data, 'POST')
  }

  async getSemesterTermDetailsBySemIDOverrideSchId(semesterID, semdID, SMT_Status, SMT_School) {
    const data = {
      semesterID: semesterID,
      SMT_Status: SMT_Status,
      semd_ID: semdID,
      token: Cookies.get('authToken'),
      UserSchool_Session: SMT_School,
    }
    return await this.callWebService('/controller/Course.asmx/getSemesterTermDetails', data, 'POST', false)
  }

  async calculateFPS(PK_Student_Course_ID) {
    const data = {
      PK_Student_Course_ID: PK_Student_Course_ID,
      token: Cookies.get('authToken'),
    }
    return await this.callWebService('/controller/Operations.asmx/calculateFPS', data, 'POST', false)
  }

  async autoApplyPlan(PK_Student_Course_ID) {
    const data = {
      PK_Student_Course_ID: PK_Student_Course_ID,
      token: Cookies.get('authToken'),
    }
    return await this.callWebService('/controller/Operations.asmx/autoApplyPlan', data, 'POST', false)
  }

  async generatePostPDF(postID, studentID) {
    return await this.callWebService(`Posts/Actions/GeneratePdf/${postID}/${studentID}`, {}, 'GET', false, false, false, 'https://api.etonhouse.com/')
  }

  async getAuthorizedPickupListDetailsReport(schoolIds) {
    const data = { schoolIds: schoolIds }
    return await this.callWebService('/controller/Api.asmx/AuthorizePickupListDetailsReport', data, 'POST')
  }
}
